//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class MceApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://mceapi.azurewebsites.net/";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1TokenEmail(body: EmailSignInRequestDto | undefined): Observable<EmailSignInDto> {
        let url_ = this.baseUrl + "/v1/token/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TokenEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TokenEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailSignInDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailSignInDto>;
        }));
    }

    protected processV1TokenEmail(response: HttpResponseBase): Observable<EmailSignInDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailSignInDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1TokenEmailValidate(token: string): Observable<EmailDtoOptionDto> {
        let url_ = this.baseUrl + "/v1/token/email/validate/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TokenEmailValidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TokenEmailValidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailDtoOptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailDtoOptionDto>;
        }));
    }

    protected processV1TokenEmailValidate(response: HttpResponseBase): Observable<EmailDtoOptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailDtoOptionDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Call to test this API controller is working
     * @return OK
     */
    v1AppCheck(): Observable<string> {
        let url_ = this.baseUrl + "/v1/appCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AppCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AppCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processV1AppCheck(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check if a Firebase App Check Token is valid
     * @return OK
     */
    v1AppCheckCheckToken(): Observable<BooleanDto> {
        let url_ = this.baseUrl + "/v1/appCheck/checkToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AppCheckCheckToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AppCheckCheckToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanDto>;
        }));
    }

    protected processV1AppCheckCheckToken(response: HttpResponseBase): Observable<BooleanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BooleanDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1BillingCreditActions(): Observable<CreditActionCostDto[]> {
        let url_ = this.baseUrl + "/v1/billing/credit-actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1BillingCreditActions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1BillingCreditActions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreditActionCostDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreditActionCostDto[]>;
        }));
    }

    protected processV1BillingCreditActions(response: HttpResponseBase): Observable<CreditActionCostDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreditActionCostDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userUid (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @return OK
     */
    v1BillingMeterEventsUser(userUid: string | undefined, startTime: Date | undefined, endTime: Date | undefined): Observable<StripeMeterEventAuditDto[]> {
        let url_ = this.baseUrl + "/v1/billing/meter-events/user?";
        if (userUid === null)
            throw new Error("The parameter 'userUid' cannot be null.");
        else if (userUid !== undefined)
            url_ += "userUid=" + encodeURIComponent("" + userUid) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1BillingMeterEventsUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1BillingMeterEventsUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StripeMeterEventAuditDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StripeMeterEventAuditDto[]>;
        }));
    }

    protected processV1BillingMeterEventsUser(response: HttpResponseBase): Observable<StripeMeterEventAuditDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StripeMeterEventAuditDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1BillingQuote(body: CreditQuoteContextDto | undefined): Observable<ChargeQuoteResultDto> {
        let url_ = this.baseUrl + "/v1/billing/quote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1BillingQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1BillingQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChargeQuoteResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChargeQuoteResultDto>;
        }));
    }

    protected processV1BillingQuote(response: HttpResponseBase): Observable<ChargeQuoteResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChargeQuoteResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1BillingCharge(body: ChargeRequestDto | undefined): Observable<ChargeResultDto> {
        let url_ = this.baseUrl + "/v1/billing/charge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1BillingCharge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1BillingCharge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChargeResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChargeResultDto>;
        }));
    }

    protected processV1BillingCharge(response: HttpResponseBase): Observable<ChargeResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChargeResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1BillingBudgetSet(body: BudgetUpdateRequestDto | undefined): Observable<BudgetUpdateResultDto> {
        let url_ = this.baseUrl + "/v1/billing/budget/set";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1BillingBudgetSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1BillingBudgetSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BudgetUpdateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BudgetUpdateResultDto>;
        }));
    }

    protected processV1BillingBudgetSet(response: HttpResponseBase): Observable<BudgetUpdateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BudgetUpdateResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1BillingBudgetSetUser(body: AdminBudgetUpdateRequestDto | undefined): Observable<BudgetUpdateResultDto> {
        let url_ = this.baseUrl + "/v1/billing/budget/set/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1BillingBudgetSetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1BillingBudgetSetUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BudgetUpdateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BudgetUpdateResultDto>;
        }));
    }

    protected processV1BillingBudgetSetUser(response: HttpResponseBase): Observable<BudgetUpdateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BudgetUpdateResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1BillingFreeTierResetUser(body: AdminFreeTierResetRequestDto | undefined): Observable<SubscriptionDto> {
        let url_ = this.baseUrl + "/v1/billing/free-tier/reset/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1BillingFreeTierResetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1BillingFreeTierResetUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionDto>;
        }));
    }

    protected processV1BillingFreeTierResetUser(response: HttpResponseBase): Observable<SubscriptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * List of standards which can be used with a given cable library guid.
     * @param body (optional) Request containing cable library guid and system voltage.
     * @return OK
     */
    v1CableCapacityStandardsByLibrary(body: StandardsRequest | undefined): Observable<StandardDto[]> {
        let url_ = this.baseUrl + "/v1/cableCapacity/standards/by-library";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableCapacityStandardsByLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableCapacityStandardsByLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StandardDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StandardDto[]>;
        }));
    }

    protected processV1CableCapacityStandardsByLibrary(response: HttpResponseBase): Observable<StandardDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StandardDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1CableCapacityCalculationUdr(body: UDRDeratingRequestDto | undefined): Observable<DeratedCurrentCalculationDto> {
        let url_ = this.baseUrl + "/v1/cableCapacity/calculation/udr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableCapacityCalculationUdr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableCapacityCalculationUdr(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeratedCurrentCalculationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeratedCurrentCalculationDto>;
        }));
    }

    protected processV1CableCapacityCalculationUdr(response: HttpResponseBase): Observable<DeratedCurrentCalculationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeratedCurrentCalculationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1CableCapacityCalculationBs7671(body: BS7671DeratingRequestDto | undefined): Observable<DeratedCurrentCalculationDto> {
        let url_ = this.baseUrl + "/v1/cableCapacity/calculation/bs7671";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableCapacityCalculationBs7671(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableCapacityCalculationBs7671(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeratedCurrentCalculationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeratedCurrentCalculationDto>;
        }));
    }

    protected processV1CableCapacityCalculationBs7671(response: HttpResponseBase): Observable<DeratedCurrentCalculationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeratedCurrentCalculationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1CableCapacityCalculationEra6930p3(body: ERA6930P3DeratingRequestDto | undefined): Observable<DeratedCurrentCalculationDto> {
        let url_ = this.baseUrl + "/v1/cableCapacity/calculation/era6930p3";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableCapacityCalculationEra6930p3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableCapacityCalculationEra6930p3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeratedCurrentCalculationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeratedCurrentCalculationDto>;
        }));
    }

    protected processV1CableCapacityCalculationEra6930p3(response: HttpResponseBase): Observable<DeratedCurrentCalculationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeratedCurrentCalculationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1CableCapacityCalculationEra6930p5(body: ERA6930P5DeratingRequestDto | undefined): Observable<DeratedCurrentCalculationDto> {
        let url_ = this.baseUrl + "/v1/cableCapacity/calculation/era6930p5";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableCapacityCalculationEra6930p5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableCapacityCalculationEra6930p5(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeratedCurrentCalculationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeratedCurrentCalculationDto>;
        }));
    }

    protected processV1CableCapacityCalculationEra6930p5(response: HttpResponseBase): Observable<DeratedCurrentCalculationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeratedCurrentCalculationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1CableCapacityCalculationIec60502p2(body: IEC60502P2DeratingRequestDto | undefined): Observable<DeratedCurrentCalculationDto> {
        let url_ = this.baseUrl + "/v1/cableCapacity/calculation/iec60502p2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableCapacityCalculationIec60502p2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableCapacityCalculationIec60502p2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeratedCurrentCalculationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeratedCurrentCalculationDto>;
        }));
    }

    protected processV1CableCapacityCalculationIec60502p2(response: HttpResponseBase): Observable<DeratedCurrentCalculationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeratedCurrentCalculationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1CableImpedance(body: ImpedanceRequestDto | undefined): Observable<ImpedanceDto> {
        let url_ = this.baseUrl + "/v1/cableImpedance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableImpedance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableImpedance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpedanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpedanceDto>;
        }));
    }

    protected processV1CableImpedance(response: HttpResponseBase): Observable<ImpedanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImpedanceDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1CableInstallationSingleCoreArrangementDC(spacing: string, value: number): Observable<SingleCoreArrangementDto> {
        let url_ = this.baseUrl + "/v1/cableInstallation/singleCoreArrangement/DC/{spacing}/{value}";
        if (spacing === undefined || spacing === null)
            throw new Error("The parameter 'spacing' must be defined.");
        url_ = url_.replace("{spacing}", encodeURIComponent("" + spacing));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableInstallationSingleCoreArrangementDC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableInstallationSingleCoreArrangementDC(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SingleCoreArrangementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SingleCoreArrangementDto>;
        }));
    }

    protected processV1CableInstallationSingleCoreArrangementDC(response: HttpResponseBase): Observable<SingleCoreArrangementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SingleCoreArrangementDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1CableInstallationSingleCoreArrangementAC1ph(spacing: string, value: number): Observable<SingleCoreArrangementDto> {
        let url_ = this.baseUrl + "/v1/cableInstallation/singleCoreArrangement/AC1ph/{spacing}/{value}";
        if (spacing === undefined || spacing === null)
            throw new Error("The parameter 'spacing' must be defined.");
        url_ = url_.replace("{spacing}", encodeURIComponent("" + spacing));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableInstallationSingleCoreArrangementAC1ph(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableInstallationSingleCoreArrangementAC1ph(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SingleCoreArrangementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SingleCoreArrangementDto>;
        }));
    }

    protected processV1CableInstallationSingleCoreArrangementAC1ph(response: HttpResponseBase): Observable<SingleCoreArrangementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SingleCoreArrangementDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1CableInstallationSingleCoreArrangementUDR(body: SystemVoltageDto | undefined): Observable<SingleCoreArrangementDto[]> {
        let url_ = this.baseUrl + "/v1/cableInstallation/singleCoreArrangementUDR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableInstallationSingleCoreArrangementUDR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableInstallationSingleCoreArrangementUDR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SingleCoreArrangementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SingleCoreArrangementDto[]>;
        }));
    }

    protected processV1CableInstallationSingleCoreArrangementUDR(response: HttpResponseBase): Observable<SingleCoreArrangementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SingleCoreArrangementDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1CableInstallationSingleCoreArrangement(libraryGuid: string, secondaryGuid: string, body: SystemVoltageDto | undefined): Observable<SingleCoreArrangementDto[]> {
        let url_ = this.baseUrl + "/v1/cableInstallation/singleCoreArrangement/{libraryGuid}/{secondaryGuid}";
        if (libraryGuid === undefined || libraryGuid === null)
            throw new Error("The parameter 'libraryGuid' must be defined.");
        url_ = url_.replace("{libraryGuid}", encodeURIComponent("" + libraryGuid));
        if (secondaryGuid === undefined || secondaryGuid === null)
            throw new Error("The parameter 'secondaryGuid' must be defined.");
        url_ = url_.replace("{secondaryGuid}", encodeURIComponent("" + secondaryGuid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableInstallationSingleCoreArrangement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableInstallationSingleCoreArrangement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SingleCoreArrangementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SingleCoreArrangementDto[]>;
        }));
    }

    protected processV1CableInstallationSingleCoreArrangement(response: HttpResponseBase): Observable<SingleCoreArrangementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SingleCoreArrangementDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1CableInstallationStandards(body: StandardsDtoRequest | undefined): Observable<GuidSelectDto[]> {
        let url_ = this.baseUrl + "/v1/cableInstallation/standards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableInstallationStandards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableInstallationStandards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuidSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuidSelectDto[]>;
        }));
    }

    protected processV1CableInstallationStandards(response: HttpResponseBase): Observable<GuidSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GuidSelectDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1CableInstallationMethodsPrimary(body: PrimaryMethodsDtoRequest | undefined): Observable<PrimaryMethodSelectDto[]> {
        let url_ = this.baseUrl + "/v1/cableInstallation/methods/primary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableInstallationMethodsPrimary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableInstallationMethodsPrimary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrimaryMethodSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrimaryMethodSelectDto[]>;
        }));
    }

    protected processV1CableInstallationMethodsPrimary(response: HttpResponseBase): Observable<PrimaryMethodSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrimaryMethodSelectDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1CableInstallationMethodsSecondary(body: SecondaryMethodsDtoRequest | undefined): Observable<SecondaryMethodSelectDto[]> {
        let url_ = this.baseUrl + "/v1/cableInstallation/methods/secondary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableInstallationMethodsSecondary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableInstallationMethodsSecondary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecondaryMethodSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecondaryMethodSelectDto[]>;
        }));
    }

    protected processV1CableInstallationMethodsSecondary(response: HttpResponseBase): Observable<SecondaryMethodSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SecondaryMethodSelectDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1CableInstallationMethodsIsBuried(secondaryMethod: string): Observable<BooleanDto> {
        let url_ = this.baseUrl + "/v1/cableInstallation/methods/{secondaryMethod}/isBuried";
        if (secondaryMethod === undefined || secondaryMethod === null)
            throw new Error("The parameter 'secondaryMethod' must be defined.");
        url_ = url_.replace("{secondaryMethod}", encodeURIComponent("" + secondaryMethod));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableInstallationMethodsIsBuried(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableInstallationMethodsIsBuried(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanDto>;
        }));
    }

    protected processV1CableInstallationMethodsIsBuried(response: HttpResponseBase): Observable<BooleanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BooleanDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1CableInstallationMethodsBS7671IsThermallyInsulatedWall(secondaryMethod: string): Observable<BooleanDto> {
        let url_ = this.baseUrl + "/v1/cableInstallation/methods/{secondaryMethod}/BS7671/isThermallyInsulatedWall";
        if (secondaryMethod === undefined || secondaryMethod === null)
            throw new Error("The parameter 'secondaryMethod' must be defined.");
        url_ = url_.replace("{secondaryMethod}", encodeURIComponent("" + secondaryMethod));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableInstallationMethodsBS7671IsThermallyInsulatedWall(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableInstallationMethodsBS7671IsThermallyInsulatedWall(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanDto>;
        }));
    }

    protected processV1CableInstallationMethodsBS7671IsThermallyInsulatedWall(response: HttpResponseBase): Observable<BooleanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BooleanDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1CableInstallationMethodsIEC60502IsOnTray(secondaryMethod: string): Observable<BooleanDto> {
        let url_ = this.baseUrl + "/v1/cableInstallation/methods/{secondaryMethod}/IEC60502/isOnTray";
        if (secondaryMethod === undefined || secondaryMethod === null)
            throw new Error("The parameter 'secondaryMethod' must be defined.");
        url_ = url_.replace("{secondaryMethod}", encodeURIComponent("" + secondaryMethod));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableInstallationMethodsIEC60502IsOnTray(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableInstallationMethodsIEC60502IsOnTray(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanDto>;
        }));
    }

    protected processV1CableInstallationMethodsIEC60502IsOnTray(response: HttpResponseBase): Observable<BooleanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BooleanDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1CablesGet(cableUid: string): Observable<CableDto> {
        let url_ = this.baseUrl + "/v1/cables/{cableUid}";
        if (cableUid === undefined || cableUid === null)
            throw new Error("The parameter 'cableUid' must be defined.");
        url_ = url_.replace("{cableUid}", encodeURIComponent("" + cableUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CablesGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CablesGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CableDto>;
        }));
    }

    protected processV1CablesGet(response: HttpResponseBase): Observable<CableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CableDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    v1CablesDelete(cableUid: string): Observable<void> {
        let url_ = this.baseUrl + "/v1/cables/{cableUid}";
        if (cableUid === undefined || cableUid === null)
            throw new Error("The parameter 'cableUid' must be defined.");
        url_ = url_.replace("{cableUid}", encodeURIComponent("" + cableUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CablesDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CablesDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1CablesDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1CablesComments(cableUid: string): Observable<CableCommentsDtoOptionDto> {
        let url_ = this.baseUrl + "/v1/cables/{cableUid}/comments";
        if (cableUid === undefined || cableUid === null)
            throw new Error("The parameter 'cableUid' must be defined.");
        url_ = url_.replace("{cableUid}", encodeURIComponent("" + cableUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CablesComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CablesComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CableCommentsDtoOptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CableCommentsDtoOptionDto>;
        }));
    }

    protected processV1CablesComments(response: HttpResponseBase): Observable<CableCommentsDtoOptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CableCommentsDtoOptionDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of cables, given a list of cable Uid.
     * @param body (optional) 
     * @return OK
     */
    v1CablesList(body: string[] | undefined): Observable<CableDto[]> {
        let url_ = this.baseUrl + "/v1/cables/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CablesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CablesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CableDto[]>;
        }));
    }

    protected processV1CablesList(response: HttpResponseBase): Observable<CableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CableDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Read cables for a given project
     * @return OK
     */
    v1CablesProject(projectUid: string): Observable<CableDto[]> {
        let url_ = this.baseUrl + "/v1/cables/project/{projectUid}";
        if (projectUid === undefined || projectUid === null)
            throw new Error("The parameter 'projectUid' must be defined.");
        url_ = url_.replace("{projectUid}", encodeURIComponent("" + projectUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CablesProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CablesProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CableDto[]>;
        }));
    }

    protected processV1CablesProject(response: HttpResponseBase): Observable<CableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CableDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Read cables (summary version) for a given project
     * @return OK
     */
    v1CablesProjectSummary(projectUid: string): Observable<CableSummaryDto[]> {
        let url_ = this.baseUrl + "/v1/cables/project/{projectUid}/summary";
        if (projectUid === undefined || projectUid === null)
            throw new Error("The parameter 'projectUid' must be defined.");
        url_ = url_.replace("{projectUid}", encodeURIComponent("" + projectUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CablesProjectSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CablesProjectSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CableSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CableSummaryDto[]>;
        }));
    }

    protected processV1CablesProjectSummary(response: HttpResponseBase): Observable<CableSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CableSummaryDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Read cable count for a given project
     * @return OK
     */
    v1CablesProjectCount(projectUid: string): Observable<Int64Dto> {
        let url_ = this.baseUrl + "/v1/cables/project/{projectUid}/count";
        if (projectUid === undefined || projectUid === null)
            throw new Error("The parameter 'projectUid' must be defined.");
        url_ = url_.replace("{projectUid}", encodeURIComponent("" + projectUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CablesProjectCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CablesProjectCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int64Dto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int64Dto>;
        }));
    }

    protected processV1CablesProjectCount(response: HttpResponseBase): Observable<Int64Dto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Int64Dto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a cable. Note this will overwrite the existing content.
     * @param body (optional) 
     * @return OK
     */
    v1CablesUpdateCable(body: CableUpdateRequestDto | undefined): Observable<CableSummaryDto> {
        let url_ = this.baseUrl + "/v1/cables/update/cable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CablesUpdateCable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CablesUpdateCable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CableSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CableSummaryDto>;
        }));
    }

    protected processV1CablesUpdateCable(response: HttpResponseBase): Observable<CableSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CableSummaryDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1CablesCopy(cableUid: string): Observable<CableSummaryDto> {
        let url_ = this.baseUrl + "/v1/cables/{cableUid}/copy";
        if (cableUid === undefined || cableUid === null)
            throw new Error("The parameter 'cableUid' must be defined.");
        url_ = url_.replace("{cableUid}", encodeURIComponent("" + cableUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CablesCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CablesCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CableSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CableSummaryDto>;
        }));
    }

    protected processV1CablesCopy(response: HttpResponseBase): Observable<CableSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CableSummaryDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1CablesUidsCopy(body: string[] | undefined): Observable<CableSummaryDto[]> {
        let url_ = this.baseUrl + "/v1/cables/uids/copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CablesUidsCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CablesUidsCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CableSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CableSummaryDto[]>;
        }));
    }

    protected processV1CablesUidsCopy(response: HttpResponseBase): Observable<CableSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CableSummaryDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectUid (optional) 
     * @return OK
     */
    v1CablesMoveProjectUid(cableUid: string, projectUid: string | undefined): Observable<CableSummaryDto> {
        let url_ = this.baseUrl + "/v1/cables/{cableUid}/move/projectUid?";
        if (cableUid === undefined || cableUid === null)
            throw new Error("The parameter 'cableUid' must be defined.");
        url_ = url_.replace("{cableUid}", encodeURIComponent("" + cableUid));
        if (projectUid === null)
            throw new Error("The parameter 'projectUid' cannot be null.");
        else if (projectUid !== undefined)
            url_ += "projectUid=" + encodeURIComponent("" + projectUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CablesMoveProjectUid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CablesMoveProjectUid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CableSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CableSummaryDto>;
        }));
    }

    protected processV1CablesMoveProjectUid(response: HttpResponseBase): Observable<CableSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CableSummaryDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectUid (optional) 
     * @param body (optional) 
     * @return OK
     */
    v1CablesUidsMoveProjectUid(projectUid: string | undefined, body: string[] | undefined): Observable<CableSummaryDto[]> {
        let url_ = this.baseUrl + "/v1/cables/uids/move/projectUid?";
        if (projectUid === null)
            throw new Error("The parameter 'projectUid' cannot be null.");
        else if (projectUid !== undefined)
            url_ += "projectUid=" + encodeURIComponent("" + projectUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CablesUidsMoveProjectUid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CablesUidsMoveProjectUid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CableSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CableSummaryDto[]>;
        }));
    }

    protected processV1CablesUidsMoveProjectUid(response: HttpResponseBase): Observable<CableSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CableSummaryDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new cable. Not saved to the database at this point.
     * @param body (optional) 
     * @return OK
     */
    v1CablesCreateCable(body: CableCreateRequestDto | undefined): Observable<CableCreateDto> {
        let url_ = this.baseUrl + "/v1/cables/create/cable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CablesCreateCable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CablesCreateCable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CableCreateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CableCreateDto>;
        }));
    }

    protected processV1CablesCreateCable(response: HttpResponseBase): Observable<CableCreateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CableCreateDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    v1CablesUidsDelete(body: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/v1/cables/uids/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CablesUidsDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CablesUidsDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1CablesUidsDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1CableLibraryRecommendSelectLibraries(sourceGuid: string): Observable<StringSelectDto[]> {
        let url_ = this.baseUrl + "/v1/cableLibrary/recommend/select/libraries/{sourceGuid}";
        if (sourceGuid === undefined || sourceGuid === null)
            throw new Error("The parameter 'sourceGuid' must be defined.");
        url_ = url_.replace("{sourceGuid}", encodeURIComponent("" + sourceGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableLibraryRecommendSelectLibraries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableLibraryRecommendSelectLibraries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringSelectDto[]>;
        }));
    }

    protected processV1CableLibraryRecommendSelectLibraries(response: HttpResponseBase): Observable<StringSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringSelectDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1CableLibraryRecommendSelectCsa(libraryGuid: string): Observable<DoubleSelectDto[]> {
        let url_ = this.baseUrl + "/v1/cableLibrary/recommend/select/csa/{libraryGuid}";
        if (libraryGuid === undefined || libraryGuid === null)
            throw new Error("The parameter 'libraryGuid' must be defined.");
        url_ = url_.replace("{libraryGuid}", encodeURIComponent("" + libraryGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableLibraryRecommendSelectCsa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableLibraryRecommendSelectCsa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoubleSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoubleSelectDto[]>;
        }));
    }

    protected processV1CableLibraryRecommendSelectCsa(response: HttpResponseBase): Observable<DoubleSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DoubleSelectDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1CableLibraryRecommend(disableVoltageFilter: boolean, body: SystemVoltageDto | undefined): Observable<CableRangeDto[]> {
        let url_ = this.baseUrl + "/v1/cableLibrary/recommend/{disableVoltageFilter}";
        if (disableVoltageFilter === undefined || disableVoltageFilter === null)
            throw new Error("The parameter 'disableVoltageFilter' must be defined.");
        url_ = url_.replace("{disableVoltageFilter}", encodeURIComponent("" + disableVoltageFilter));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableLibraryRecommend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableLibraryRecommend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CableRangeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CableRangeDto[]>;
        }));
    }

    protected processV1CableLibraryRecommend(response: HttpResponseBase): Observable<CableRangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CableRangeDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1CableLibraryArmoured(libraryUid: string): Observable<BooleanDto> {
        let url_ = this.baseUrl + "/v1/cableLibrary/{libraryUid}/armoured";
        if (libraryUid === undefined || libraryUid === null)
            throw new Error("The parameter 'libraryUid' must be defined.");
        url_ = url_.replace("{libraryUid}", encodeURIComponent("" + libraryUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableLibraryArmoured(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableLibraryArmoured(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanDto>;
        }));
    }

    protected processV1CableLibraryArmoured(response: HttpResponseBase): Observable<BooleanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BooleanDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1CableLibraryScreened(libraryUid: string): Observable<BooleanDto> {
        let url_ = this.baseUrl + "/v1/cableLibrary/{libraryUid}/screened";
        if (libraryUid === undefined || libraryUid === null)
            throw new Error("The parameter 'libraryUid' must be defined.");
        url_ = url_.replace("{libraryUid}", encodeURIComponent("" + libraryUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableLibraryScreened(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableLibraryScreened(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanDto>;
        }));
    }

    protected processV1CableLibraryScreened(response: HttpResponseBase): Observable<BooleanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BooleanDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1CableLibrarySparecore(libraryUid: string, body: SystemVoltageDto | undefined): Observable<BooleanDto> {
        let url_ = this.baseUrl + "/v1/cableLibrary/{libraryUid}/sparecore";
        if (libraryUid === undefined || libraryUid === null)
            throw new Error("The parameter 'libraryUid' must be defined.");
        url_ = url_.replace("{libraryUid}", encodeURIComponent("" + libraryUid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableLibrarySparecore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableLibrarySparecore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanDto>;
        }));
    }

    protected processV1CableLibrarySparecore(response: HttpResponseBase): Observable<BooleanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BooleanDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1CableLibrarySinglecore(libraryUid: string, body: SystemVoltageDto | undefined): Observable<BooleanDto> {
        let url_ = this.baseUrl + "/v1/cableLibrary/{libraryUid}/singlecore";
        if (libraryUid === undefined || libraryUid === null)
            throw new Error("The parameter 'libraryUid' must be defined.");
        url_ = url_.replace("{libraryUid}", encodeURIComponent("" + libraryUid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableLibrarySinglecore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableLibrarySinglecore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanDto>;
        }));
    }

    protected processV1CableLibrarySinglecore(response: HttpResponseBase): Observable<BooleanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BooleanDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Datasheet for a cable of LibraryGuid and given CSA.
     * @param csa The CSA (mm2) of the requested cable.
     * @return OK
     */
    v1CableLibraryDatasheet(libraryUid: string, csa: number): Observable<CableDatasheetDtoOptionDto> {
        let url_ = this.baseUrl + "/v1/cableLibrary/{libraryUid}/{csa}/datasheet";
        if (libraryUid === undefined || libraryUid === null)
            throw new Error("The parameter 'libraryUid' must be defined.");
        url_ = url_.replace("{libraryUid}", encodeURIComponent("" + libraryUid));
        if (csa === undefined || csa === null)
            throw new Error("The parameter 'csa' must be defined.");
        url_ = url_.replace("{csa}", encodeURIComponent("" + csa));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableLibraryDatasheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableLibraryDatasheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CableDatasheetDtoOptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CableDatasheetDtoOptionDto>;
        }));
    }

    protected processV1CableLibraryDatasheet(response: HttpResponseBase): Observable<CableDatasheetDtoOptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CableDatasheetDtoOptionDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1CableLibraryDatasheetHtml(libraryUid: string, csa: number): Observable<HTMLDtoOptionDto> {
        let url_ = this.baseUrl + "/v1/cableLibrary/{libraryUid}/{csa}/datasheet/html";
        if (libraryUid === undefined || libraryUid === null)
            throw new Error("The parameter 'libraryUid' must be defined.");
        url_ = url_.replace("{libraryUid}", encodeURIComponent("" + libraryUid));
        if (csa === undefined || csa === null)
            throw new Error("The parameter 'csa' must be defined.");
        url_ = url_.replace("{csa}", encodeURIComponent("" + csa));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableLibraryDatasheetHtml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableLibraryDatasheetHtml(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HTMLDtoOptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HTMLDtoOptionDto>;
        }));
    }

    protected processV1CableLibraryDatasheetHtml(response: HttpResponseBase): Observable<HTMLDtoOptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HTMLDtoOptionDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * List of cable manufacturers.
     * @return OK
     */
    v1CableLibraryManufacturers(): Observable<ManufacturerDto[]> {
        let url_ = this.baseUrl + "/v1/cableLibrary/manufacturers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableLibraryManufacturers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableLibraryManufacturers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManufacturerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManufacturerDto[]>;
        }));
    }

    protected processV1CableLibraryManufacturers(response: HttpResponseBase): Observable<ManufacturerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ManufacturerDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1CableLibraryManufacturersSources(manufacturerUid: string): Observable<StringSelectDto[]> {
        let url_ = this.baseUrl + "/v1/cableLibrary/manufacturers/{manufacturerUid}/sources";
        if (manufacturerUid === undefined || manufacturerUid === null)
            throw new Error("The parameter 'manufacturerUid' must be defined.");
        url_ = url_.replace("{manufacturerUid}", encodeURIComponent("" + manufacturerUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableLibraryManufacturersSources(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableLibraryManufacturersSources(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringSelectDto[]>;
        }));
    }

    protected processV1CableLibraryManufacturersSources(response: HttpResponseBase): Observable<StringSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringSelectDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1CableLibraryManufacturersLibrary(manufacturerUid: string, rangeUid: string): Observable<StringSelectDto[]> {
        let url_ = this.baseUrl + "/v1/cableLibrary/manufacturers/{manufacturerUid}/library/{rangeUid}";
        if (manufacturerUid === undefined || manufacturerUid === null)
            throw new Error("The parameter 'manufacturerUid' must be defined.");
        url_ = url_.replace("{manufacturerUid}", encodeURIComponent("" + manufacturerUid));
        if (rangeUid === undefined || rangeUid === null)
            throw new Error("The parameter 'rangeUid' must be defined.");
        url_ = url_.replace("{rangeUid}", encodeURIComponent("" + rangeUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableLibraryManufacturersLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableLibraryManufacturersLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringSelectDto[]>;
        }));
    }

    protected processV1CableLibraryManufacturersLibrary(response: HttpResponseBase): Observable<StringSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringSelectDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1CableLibraryManufacturersCsa(manufacturerUid: string, libraryUid: string): Observable<DoubleSelectDto[]> {
        let url_ = this.baseUrl + "/v1/cableLibrary/manufacturers/{manufacturerUid}/csa/{libraryUid}";
        if (manufacturerUid === undefined || manufacturerUid === null)
            throw new Error("The parameter 'manufacturerUid' must be defined.");
        url_ = url_.replace("{manufacturerUid}", encodeURIComponent("" + manufacturerUid));
        if (libraryUid === undefined || libraryUid === null)
            throw new Error("The parameter 'libraryUid' must be defined.");
        url_ = url_.replace("{libraryUid}", encodeURIComponent("" + libraryUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableLibraryManufacturersCsa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableLibraryManufacturersCsa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoubleSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoubleSelectDto[]>;
        }));
    }

    protected processV1CableLibraryManufacturersCsa(response: HttpResponseBase): Observable<DoubleSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DoubleSelectDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1CableVoltageDrop(body: VoltageDropRequestDto | undefined): Observable<VoltageDropDto> {
        let url_ = this.baseUrl + "/v1/cableVoltageDrop";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CableVoltageDrop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CableVoltageDrop(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoltageDropDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoltageDropDto>;
        }));
    }

    protected processV1CableVoltageDrop(response: HttpResponseBase): Observable<VoltageDropDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoltageDropDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1CalculationDesignCurrent(body: DesignCurrentRequestDto | undefined): Observable<DesignCurrentDto> {
        let url_ = this.baseUrl + "/v1/calculation/designCurrent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CalculationDesignCurrent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CalculationDesignCurrent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DesignCurrentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DesignCurrentDto>;
        }));
    }

    protected processV1CalculationDesignCurrent(response: HttpResponseBase): Observable<DesignCurrentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DesignCurrentDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1CalculationConductorTemperature(body: ConductorTemperatureRequestDto | undefined): Observable<ConductorTemperatureResultDto> {
        let url_ = this.baseUrl + "/v1/calculation/conductorTemperature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CalculationConductorTemperature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CalculationConductorTemperature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConductorTemperatureResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConductorTemperatureResultDto>;
        }));
    }

    protected processV1CalculationConductorTemperature(response: HttpResponseBase): Observable<ConductorTemperatureResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConductorTemperatureResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * List of countries, with their alpha2 code.
     * @return OK
     */
    v1Countries(): Observable<StringSelectDto[]> {
        let url_ = this.baseUrl + "/v1/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1Countries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1Countries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringSelectDto[]>;
        }));
    }

    protected processV1Countries(response: HttpResponseBase): Observable<StringSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringSelectDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reference values for a country for a of given ISO alpha2.
     * @param isoAlpha2 ISO two letter country identifier.
     * @return OK
     */
    v1CountriesReferenceValues(isoAlpha2: string): Observable<CountryReferenceValuesDto> {
        let url_ = this.baseUrl + "/v1/countries/{isoAlpha2}/referenceValues";
        if (isoAlpha2 === undefined || isoAlpha2 === null)
            throw new Error("The parameter 'isoAlpha2' must be defined.");
        url_ = url_.replace("{isoAlpha2}", encodeURIComponent("" + isoAlpha2));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CountriesReferenceValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CountriesReferenceValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryReferenceValuesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryReferenceValuesDto>;
        }));
    }

    protected processV1CountriesReferenceValues(response: HttpResponseBase): Observable<CountryReferenceValuesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CountryReferenceValuesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Flag [base64] for a country for a of given ISO alpha2.
     * @param isoAlpha2 ISO two letter country identifier.
     * @return OK
     */
    v1CountriesFlag64(isoAlpha2: string): Observable<Flag64DtoOptionDto> {
        let url_ = this.baseUrl + "/v1/countries/{isoAlpha2}/flag64";
        if (isoAlpha2 === undefined || isoAlpha2 === null)
            throw new Error("The parameter 'isoAlpha2' must be defined.");
        url_ = url_.replace("{isoAlpha2}", encodeURIComponent("" + isoAlpha2));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CountriesFlag64(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CountriesFlag64(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Flag64DtoOptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Flag64DtoOptionDto>;
        }));
    }

    protected processV1CountriesFlag64(response: HttpResponseBase): Observable<Flag64DtoOptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Flag64DtoOptionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a current model for a given dc current.
     * @param current The value of the dc current in amps.
     * @return OK
     */
    v1CurrentDc(current: number): Observable<IDto> {
        let url_ = this.baseUrl + "/v1/current/dc/{current}";
        if (current === undefined || current === null)
            throw new Error("The parameter 'current' must be defined.");
        url_ = url_.replace("{current}", encodeURIComponent("" + current));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CurrentDc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CurrentDc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IDto>;
        }));
    }

    protected processV1CurrentDc(response: HttpResponseBase): Observable<IDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a current model for a given single-phase ac current (current, phase angle).
     * @param current The line to earth value of the ac current in amps.
     * @param phaseAngle The phase angle in degrees of the ac current.
     * @return OK
     */
    v1CurrentAc(current: number, phaseAngle: number): Observable<IpDto> {
        let url_ = this.baseUrl + "/v1/current/ac/{current}/{phaseAngle}";
        if (current === undefined || current === null)
            throw new Error("The parameter 'current' must be defined.");
        url_ = url_.replace("{current}", encodeURIComponent("" + current));
        if (phaseAngle === undefined || phaseAngle === null)
            throw new Error("The parameter 'phaseAngle' must be defined.");
        url_ = url_.replace("{phaseAngle}", encodeURIComponent("" + phaseAngle));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CurrentAc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CurrentAc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IpDto>;
        }));
    }

    protected processV1CurrentAc(response: HttpResponseBase): Observable<IpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IpDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a current model for a given single-phase ac current (current, power factor).
     * @param current The line to earth value of the ac current in amps.
     * @param pf The power factor [value]of the ac current.
     * @param lagging If lagging/leading [true/false] of the ac current.
     * @return OK
     */
    v1CurrentAcPf(current: number, pf: number, lagging: boolean): Observable<IpDto> {
        let url_ = this.baseUrl + "/v1/current/ac/pf/{current}/{pf}/{lagging}";
        if (current === undefined || current === null)
            throw new Error("The parameter 'current' must be defined.");
        url_ = url_.replace("{current}", encodeURIComponent("" + current));
        if (pf === undefined || pf === null)
            throw new Error("The parameter 'pf' must be defined.");
        url_ = url_.replace("{pf}", encodeURIComponent("" + pf));
        if (lagging === undefined || lagging === null)
            throw new Error("The parameter 'lagging' must be defined.");
        url_ = url_.replace("{lagging}", encodeURIComponent("" + lagging));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CurrentAcPf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CurrentAcPf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IpDto>;
        }));
    }

    protected processV1CurrentAcPf(response: HttpResponseBase): Observable<IpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IpDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a system current model for a given dc current.
     * @return OK
     */
    v1CurrentSystemDc(current: number): Observable<SystemCurrentDto> {
        let url_ = this.baseUrl + "/v1/current/system/dc/{current}";
        if (current === undefined || current === null)
            throw new Error("The parameter 'current' must be defined.");
        url_ = url_.replace("{current}", encodeURIComponent("" + current));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CurrentSystemDc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CurrentSystemDc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemCurrentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemCurrentDto>;
        }));
    }

    protected processV1CurrentSystemDc(response: HttpResponseBase): Observable<SystemCurrentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SystemCurrentDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a system current model for a given ac current.
     * @param phaseAngle The phase angle in degrees of the ac current.
     * @return OK
     */
    v1CurrentSystemAc(current: number, phaseAngle: number): Observable<SystemCurrentDto> {
        let url_ = this.baseUrl + "/v1/current/system/ac/{current}/{phaseAngle}";
        if (current === undefined || current === null)
            throw new Error("The parameter 'current' must be defined.");
        url_ = url_.replace("{current}", encodeURIComponent("" + current));
        if (phaseAngle === undefined || phaseAngle === null)
            throw new Error("The parameter 'phaseAngle' must be defined.");
        url_ = url_.replace("{phaseAngle}", encodeURIComponent("" + phaseAngle));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CurrentSystemAc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CurrentSystemAc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemCurrentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemCurrentDto>;
        }));
    }

    protected processV1CurrentSystemAc(response: HttpResponseBase): Observable<SystemCurrentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SystemCurrentDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a system current model for a given ac current.
     * @param pf The power factor [value]of the ac current.
     * @param lagging If lagging/leading [true/false] of the ac current.
     * @return OK
     */
    v1CurrentSystemAcPf(current: number, pf: number, lagging: boolean): Observable<SystemCurrentDto> {
        let url_ = this.baseUrl + "/v1/current/system/ac/pf/{current}/{pf}/{lagging}";
        if (current === undefined || current === null)
            throw new Error("The parameter 'current' must be defined.");
        url_ = url_.replace("{current}", encodeURIComponent("" + current));
        if (pf === undefined || pf === null)
            throw new Error("The parameter 'pf' must be defined.");
        url_ = url_.replace("{pf}", encodeURIComponent("" + pf));
        if (lagging === undefined || lagging === null)
            throw new Error("The parameter 'lagging' must be defined.");
        url_ = url_.replace("{lagging}", encodeURIComponent("" + lagging));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CurrentSystemAcPf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CurrentSystemAcPf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemCurrentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemCurrentDto>;
        }));
    }

    protected processV1CurrentSystemAcPf(response: HttpResponseBase): Observable<SystemCurrentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SystemCurrentDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1EarthingCpcCsaPreferred(): Observable<DoubleSelectDto> {
        let url_ = this.baseUrl + "/v1/earthing/cpc/csa/preferred";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1EarthingCpcCsaPreferred(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1EarthingCpcCsaPreferred(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoubleSelectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoubleSelectDto>;
        }));
    }

    protected processV1EarthingCpcCsaPreferred(response: HttpResponseBase): Observable<DoubleSelectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DoubleSelectDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1Efl(body: EFLCalculationRequestDto | undefined): Observable<EFLCalculationResultDto> {
        let url_ = this.baseUrl + "/v1/efl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1Efl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1Efl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EFLCalculationResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EFLCalculationResultDto>;
        }));
    }

    protected processV1Efl(response: HttpResponseBase): Observable<EFLCalculationResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EFLCalculationResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1EflRequired(body: EFLRequiredRequestDto | undefined): Observable<BooleanDto> {
        let url_ = this.baseUrl + "/v1/efl/required";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1EflRequired(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1EflRequired(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanDto>;
        }));
    }

    protected processV1EflRequired(response: HttpResponseBase): Observable<BooleanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BooleanDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adiabatic K factor based on conductor properties and insulation temperature limits (initial and final).
     * @param qc Volumetric heat capacity of conductor joule/(kelvin metre^2).
     * @param rho Resistivity of conductors material (ohm metre).
     * @param alpha Temperature coefficient of conductor (1/kelvin).
     * @param ti Operating temperature of conductor/insulation temperature) (°C Celsius).
     * @param tf Final limiting temperature of insulation (°C Celsius).
     * @return OK
     */
    v1ElectricalAdiabaticsKFactor(qc: number, rho: number, alpha: number, ti: number, tf: number): Observable<KFactorDto> {
        let url_ = this.baseUrl + "/v1/electrical/adiabatics/kFactor/{qc}/{rho}/{alpha}/{ti}/{tf}";
        if (qc === undefined || qc === null)
            throw new Error("The parameter 'qc' must be defined.");
        url_ = url_.replace("{qc}", encodeURIComponent("" + qc));
        if (rho === undefined || rho === null)
            throw new Error("The parameter 'rho' must be defined.");
        url_ = url_.replace("{rho}", encodeURIComponent("" + rho));
        if (alpha === undefined || alpha === null)
            throw new Error("The parameter 'alpha' must be defined.");
        url_ = url_.replace("{alpha}", encodeURIComponent("" + alpha));
        if (ti === undefined || ti === null)
            throw new Error("The parameter 'ti' must be defined.");
        url_ = url_.replace("{ti}", encodeURIComponent("" + ti));
        if (tf === undefined || tf === null)
            throw new Error("The parameter 'tf' must be defined.");
        url_ = url_.replace("{tf}", encodeURIComponent("" + tf));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ElectricalAdiabaticsKFactor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ElectricalAdiabaticsKFactor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KFactorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KFactorDto>;
        }));
    }

    protected processV1ElectricalAdiabaticsKFactor(response: HttpResponseBase): Observable<KFactorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KFactorDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1FaultCalculationRequestLevel(body: FaultLevelFromImpedanceRequestDto | undefined): Observable<FaultLevelFromImpedanceResponseDto> {
        let url_ = this.baseUrl + "/v1/fault/calculation/request/level";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1FaultCalculationRequestLevel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1FaultCalculationRequestLevel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FaultLevelFromImpedanceResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FaultLevelFromImpedanceResponseDto>;
        }));
    }

    protected processV1FaultCalculationRequestLevel(response: HttpResponseBase): Observable<FaultLevelFromImpedanceResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FaultLevelFromImpedanceResponseDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1FaultCalculationRequestImpedance(body: FaultImpedanceFromLevelRequestDto | undefined): Observable<FaultImpedanceFromLevelResponseDto> {
        let url_ = this.baseUrl + "/v1/fault/calculation/request/impedance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1FaultCalculationRequestImpedance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1FaultCalculationRequestImpedance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FaultImpedanceFromLevelResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FaultImpedanceFromLevelResponseDto>;
        }));
    }

    protected processV1FaultCalculationRequestImpedance(response: HttpResponseBase): Observable<FaultImpedanceFromLevelResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FaultImpedanceFromLevelResponseDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1Fault(body: CableFaultRequestDto | undefined): Observable<CableFaultDto> {
        let url_ = this.baseUrl + "/v1/fault";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1Fault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1Fault(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CableFaultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CableFaultDto>;
        }));
    }

    protected processV1Fault(response: HttpResponseBase): Observable<CableFaultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CableFaultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * List of supported currencies.
     * @return OK
     */
    v1FinancialCurrencyCodes(): Observable<SymbolDto[]> {
        let url_ = this.baseUrl + "/v1/financial/currency/codes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1FinancialCurrencyCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1FinancialCurrencyCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SymbolDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SymbolDto[]>;
        }));
    }

    protected processV1FinancialCurrencyCodes(response: HttpResponseBase): Observable<SymbolDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SymbolDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Current exchange rate.
     * @return OK
     */
    v1FinancialCurrencyExchangeRate(baseCode: string, targetCode: string): Observable<ExchangeRateDto> {
        let url_ = this.baseUrl + "/v1/financial/currency/exchangeRate/{baseCode}/{targetCode}";
        if (baseCode === undefined || baseCode === null)
            throw new Error("The parameter 'baseCode' must be defined.");
        url_ = url_.replace("{baseCode}", encodeURIComponent("" + baseCode));
        if (targetCode === undefined || targetCode === null)
            throw new Error("The parameter 'targetCode' must be defined.");
        url_ = url_.replace("{targetCode}", encodeURIComponent("" + targetCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1FinancialCurrencyExchangeRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1FinancialCurrencyExchangeRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExchangeRateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExchangeRateDto>;
        }));
    }

    protected processV1FinancialCurrencyExchangeRate(response: HttpResponseBase): Observable<ExchangeRateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExchangeRateDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get an impedance given its resistance and reactance in ohms.
     * @return OK
     */
    v1Impedance(r: number, x: number): Observable<ImpedanceResultDto> {
        let url_ = this.baseUrl + "/v1/impedance/{r}/{x}";
        if (r === undefined || r === null)
            throw new Error("The parameter 'r' must be defined.");
        url_ = url_.replace("{r}", encodeURIComponent("" + r));
        if (x === undefined || x === null)
            throw new Error("The parameter 'x' must be defined.");
        url_ = url_.replace("{x}", encodeURIComponent("" + x));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1Impedance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1Impedance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpedanceResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpedanceResultDto>;
        }));
    }

    protected processV1Impedance(response: HttpResponseBase): Observable<ImpedanceResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImpedanceResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get an impedance given its magnitude in ohms and X/R ratio.
     * @return OK
     */
    v1ImpedanceMagnitudeXrRatio(magnitude: number, xrRatio: number): Observable<ImpedanceResultDto> {
        let url_ = this.baseUrl + "/v1/impedance/magnitude/{magnitude}/xr-ratio/{xrRatio}";
        if (magnitude === undefined || magnitude === null)
            throw new Error("The parameter 'magnitude' must be defined.");
        url_ = url_.replace("{magnitude}", encodeURIComponent("" + magnitude));
        if (xrRatio === undefined || xrRatio === null)
            throw new Error("The parameter 'xrRatio' must be defined.");
        url_ = url_.replace("{xrRatio}", encodeURIComponent("" + xrRatio));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ImpedanceMagnitudeXrRatio(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ImpedanceMagnitudeXrRatio(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpedanceResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpedanceResultDto>;
        }));
    }

    protected processV1ImpedanceMagnitudeXrRatio(response: HttpResponseBase): Observable<ImpedanceResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImpedanceResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1LoadsLegacy(key: string): Observable<LoadTypeDto> {
        let url_ = this.baseUrl + "/v1/loads/legacy/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1LoadsLegacy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1LoadsLegacy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadTypeDto>;
        }));
    }

    protected processV1LoadsLegacy(response: HttpResponseBase): Observable<LoadTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoadTypeDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of legacy loads for a given voltage. The intent is to update this
    once we introduce smart loads.
     * @param body (optional) 
     * @return OK
     */
    v1LoadsLegacyLoads(body: SystemVoltageDto | undefined): Observable<LoadTypeDto[]> {
        let url_ = this.baseUrl + "/v1/loads/legacy/loads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1LoadsLegacyLoads(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1LoadsLegacyLoads(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadTypeDto[]>;
        }));
    }

    protected processV1LoadsLegacyLoads(response: HttpResponseBase): Observable<LoadTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoadTypeDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1LoadsPowerDc(body: RequestCalculatePower | undefined): Observable<PDto> {
        let url_ = this.baseUrl + "/v1/loads/power/dc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1LoadsPowerDc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1LoadsPowerDc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PDto>;
        }));
    }

    protected processV1LoadsPowerDc(response: HttpResponseBase): Observable<PDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1LoadsPowerAc(body: RequestCalculatePower | undefined): Observable<ComplexPowerDto> {
        let url_ = this.baseUrl + "/v1/loads/power/ac";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1LoadsPowerAc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1LoadsPowerAc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComplexPowerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComplexPowerDto>;
        }));
    }

    protected processV1LoadsPowerAc(response: HttpResponseBase): Observable<ComplexPowerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComplexPowerDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1LoadsCurrentDc(body: RequestCalculateI | undefined): Observable<IDto> {
        let url_ = this.baseUrl + "/v1/loads/current/dc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1LoadsCurrentDc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1LoadsCurrentDc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IDto>;
        }));
    }

    protected processV1LoadsCurrentDc(response: HttpResponseBase): Observable<IDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Calculate the current for a given real power and system voltage
     * @param body (optional) 
     * @return OK
     */
    v1LoadsCurrentAcReal(body: RequestCalculateIpFromP | undefined): Observable<IpDto> {
        let url_ = this.baseUrl + "/v1/loads/current/ac/real";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1LoadsCurrentAcReal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1LoadsCurrentAcReal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IpDto>;
        }));
    }

    protected processV1LoadsCurrentAcReal(response: HttpResponseBase): Observable<IpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IpDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Calculate the current for a given apparent power and system voltage
     * @param body (optional) 
     * @return OK
     */
    v1LoadsCurrentAcApparent(body: RequestCalculateIpFromS | undefined): Observable<IpDto> {
        let url_ = this.baseUrl + "/v1/loads/current/ac/apparent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1LoadsCurrentAcApparent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1LoadsCurrentAcApparent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IpDto>;
        }));
    }

    protected processV1LoadsCurrentAcApparent(response: HttpResponseBase): Observable<IpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IpDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1ManufacturersEquipmentTypes(): Observable<EquipmentTypeDUDto[]> {
        let url_ = this.baseUrl + "/v1/manufacturers/equipmentTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ManufacturersEquipmentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ManufacturersEquipmentTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentTypeDUDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentTypeDUDto[]>;
        }));
    }

    protected processV1ManufacturersEquipmentTypes(response: HttpResponseBase): Observable<EquipmentTypeDUDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EquipmentTypeDUDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1ManufacturersEquipment(equipmentType: string): Observable<ManufacturerDto[]> {
        let url_ = this.baseUrl + "/v1/manufacturers/equipment/{equipmentType}";
        if (equipmentType === undefined || equipmentType === null)
            throw new Error("The parameter 'equipmentType' must be defined.");
        url_ = url_.replace("{equipmentType}", encodeURIComponent("" + equipmentType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ManufacturersEquipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ManufacturersEquipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManufacturerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManufacturerDto[]>;
        }));
    }

    protected processV1ManufacturersEquipment(response: HttpResponseBase): Observable<ManufacturerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ManufacturerDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * List of conductor materials, with their properties.
     * @return OK
     */
    v1MaterialsConductors(): Observable<MaterialConductorDto[]> {
        let url_ = this.baseUrl + "/v1/materials/conductors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MaterialsConductors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MaterialsConductors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialConductorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialConductorDto[]>;
        }));
    }

    protected processV1MaterialsConductors(response: HttpResponseBase): Observable<MaterialConductorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaterialConductorDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1MaterialsConductorsPricesLatestHtml(): Observable<HTMLDto> {
        let url_ = this.baseUrl + "/v1/materials/conductors/prices/latest/html";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MaterialsConductorsPricesLatestHtml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MaterialsConductorsPricesLatestHtml(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HTMLDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HTMLDto>;
        }));
    }

    protected processV1MaterialsConductorsPricesLatestHtml(response: HttpResponseBase): Observable<HTMLDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HTMLDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * List of insulation materials, with their properties.
     * @return OK
     */
    v1MaterialsInsulations(): Observable<MaterialInsulationDto[]> {
        let url_ = this.baseUrl + "/v1/materials/insulations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MaterialsInsulations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MaterialsInsulations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialInsulationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialInsulationDto[]>;
        }));
    }

    protected processV1MaterialsInsulations(response: HttpResponseBase): Observable<MaterialInsulationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaterialInsulationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Properties for a material of given Id.
     * @param guid The Guid of the material.
     * @return OK
     */
    v1Materials(guid: string): Observable<MaterialInsulationDtoFSharpOption> {
        let url_ = this.baseUrl + "/v1/materials/{guid}";
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1Materials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1Materials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialInsulationDtoFSharpOption>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialInsulationDtoFSharpOption>;
        }));
    }

    protected processV1Materials(response: HttpResponseBase): Observable<MaterialInsulationDtoFSharpOption> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaterialInsulationDtoFSharpOption;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Properties for a material of a given Code. Note that the value of the code may change, and as such
    a better approach is to use the material Id.
     * @param code The Code of the material.
     * @return OK
     */
    v1MaterialsCode(code: string): Observable<MaterialInsulationDtoFSharpOption> {
        let url_ = this.baseUrl + "/v1/materials/code/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MaterialsCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MaterialsCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialInsulationDtoFSharpOption>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialInsulationDtoFSharpOption>;
        }));
    }

    protected processV1MaterialsCode(response: HttpResponseBase): Observable<MaterialInsulationDtoFSharpOption> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaterialInsulationDtoFSharpOption;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the price for a material. Currently only copper (Cu) and aluminum (Al) are supported.
     * @param materialCode The Code of the material i.e. Cu).
     * @param currencyCode The code of the pricing currency, i,e. GBP
     * @return OK
     */
    v1MaterialsCodePrice(materialCode: string, currencyCode: string): Observable<MetalRateDto> {
        let url_ = this.baseUrl + "/v1/materials/code/{materialCode}/price/{currencyCode}";
        if (materialCode === undefined || materialCode === null)
            throw new Error("The parameter 'materialCode' must be defined.");
        url_ = url_.replace("{materialCode}", encodeURIComponent("" + materialCode));
        if (currencyCode === undefined || currencyCode === null)
            throw new Error("The parameter 'currencyCode' must be defined.");
        url_ = url_.replace("{currencyCode}", encodeURIComponent("" + currencyCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MaterialsCodePrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MaterialsCodePrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetalRateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetalRateDto>;
        }));
    }

    protected processV1MaterialsCodePrice(response: HttpResponseBase): Observable<MetalRateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MetalRateDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1MathsComplex(real: number, imaginary: number): Observable<ComplexDto> {
        let url_ = this.baseUrl + "/v1/maths/complex/{real}/{imaginary}";
        if (real === undefined || real === null)
            throw new Error("The parameter 'real' must be defined.");
        url_ = url_.replace("{real}", encodeURIComponent("" + real));
        if (imaginary === undefined || imaginary === null)
            throw new Error("The parameter 'imaginary' must be defined.");
        url_ = url_.replace("{imaginary}", encodeURIComponent("" + imaginary));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MathsComplex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MathsComplex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComplexDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComplexDto>;
        }));
    }

    protected processV1MathsComplex(response: HttpResponseBase): Observable<ComplexDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComplexDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1PowerPowerReal(body: PowerRequestDto | undefined): Observable<PDto> {
        let url_ = this.baseUrl + "/v1/power/power/real";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PowerPowerReal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PowerPowerReal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PDto>;
        }));
    }

    protected processV1PowerPowerReal(response: HttpResponseBase): Observable<PDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1PowerPowerReactive(body: PowerRequestDto | undefined): Observable<QDto> {
        let url_ = this.baseUrl + "/v1/power/power/reactive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PowerPowerReactive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PowerPowerReactive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QDto>;
        }));
    }

    protected processV1PowerPowerReactive(response: HttpResponseBase): Observable<QDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1PowerPowerApparent(body: PowerRequestDto | undefined): Observable<SDto> {
        let url_ = this.baseUrl + "/v1/power/power/apparent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PowerPowerApparent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PowerPowerApparent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SDto>;
        }));
    }

    protected processV1PowerPowerApparent(response: HttpResponseBase): Observable<SDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Determine the power factor Dto for a given power factor and if leading/lagging.
     * @return OK
     */
    v1PowerFactor(pf: number, lagging: boolean): Observable<PFDto> {
        let url_ = this.baseUrl + "/v1/powerFactor/{pf}/{lagging}";
        if (pf === undefined || pf === null)
            throw new Error("The parameter 'pf' must be defined.");
        url_ = url_.replace("{pf}", encodeURIComponent("" + pf));
        if (lagging === undefined || lagging === null)
            throw new Error("The parameter 'lagging' must be defined.");
        url_ = url_.replace("{lagging}", encodeURIComponent("" + lagging));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PowerFactor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PowerFactor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PFDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PFDto>;
        }));
    }

    protected processV1PowerFactor(response: HttpResponseBase): Observable<PFDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PFDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Determine the power factor for a given ac current.
     * @param body (optional) 
     * @return OK
     */
    v1PowerFactorCurrent(body: IpDto | undefined): Observable<PFDto> {
        let url_ = this.baseUrl + "/v1/powerFactor/current";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PowerFactorCurrent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PowerFactorCurrent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PFDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PFDto>;
        }));
    }

    protected processV1PowerFactorCurrent(response: HttpResponseBase): Observable<PFDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PFDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Determine the power factor for a given ac load.
     * @param body (optional) 
     * @return OK
     */
    v1PowerFactorLoad(body: LoadDto | undefined): Observable<PFDto> {
        let url_ = this.baseUrl + "/v1/powerFactor/load";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PowerFactorLoad(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PowerFactorLoad(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PFDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PFDto>;
        }));
    }

    protected processV1PowerFactorLoad(response: HttpResponseBase): Observable<PFDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PFDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1PowerLoss(body: PowerLossRequestDto | undefined): Observable<PowerLossDto> {
        let url_ = this.baseUrl + "/v1/powerLoss";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PowerLoss(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PowerLoss(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PowerLossDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PowerLossDto>;
        }));
    }

    protected processV1PowerLoss(response: HttpResponseBase): Observable<PowerLossDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PowerLossDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1ProjectsGet(projectUid: string): Observable<ProjectDto> {
        let url_ = this.baseUrl + "/v1/projects/{projectUid}";
        if (projectUid === undefined || projectUid === null)
            throw new Error("The parameter 'projectUid' must be defined.");
        url_ = url_.replace("{projectUid}", encodeURIComponent("" + projectUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProjectsGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProjectsGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDto>;
        }));
    }

    protected processV1ProjectsGet(response: HttpResponseBase): Observable<ProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    v1ProjectsDelete(projectUid: string): Observable<void> {
        let url_ = this.baseUrl + "/v1/projects/{projectUid}";
        if (projectUid === undefined || projectUid === null)
            throw new Error("The parameter 'projectUid' must be defined.");
        url_ = url_.replace("{projectUid}", encodeURIComponent("" + projectUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProjectsDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProjectsDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1ProjectsDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1ProjectsComments(projectUid: string): Observable<ProjectCommentsDtoOptionDto> {
        let url_ = this.baseUrl + "/v1/projects/{projectUid}/comments";
        if (projectUid === undefined || projectUid === null)
            throw new Error("The parameter 'projectUid' must be defined.");
        url_ = url_.replace("{projectUid}", encodeURIComponent("" + projectUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProjectsComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProjectsComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectCommentsDtoOptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectCommentsDtoOptionDto>;
        }));
    }

    protected processV1ProjectsComments(response: HttpResponseBase): Observable<ProjectCommentsDtoOptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectCommentsDtoOptionDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of projects, given a list of project Uid.
     * @param body (optional) 
     * @return OK
     */
    v1ProjectsList(body: string[] | undefined): Observable<ProjectDto[]> {
        let url_ = this.baseUrl + "/v1/projects/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProjectsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProjectsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDto[]>;
        }));
    }

    protected processV1ProjectsList(response: HttpResponseBase): Observable<ProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the users for a given project
     * @return OK
     */
    v1ProjectsUsers(projectUid: string): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/v1/projects/{projectUid}/users";
        if (projectUid === undefined || projectUid === null)
            throw new Error("The parameter 'projectUid' must be defined.");
        url_ = url_.replace("{projectUid}", encodeURIComponent("" + projectUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProjectsUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProjectsUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processV1ProjectsUsers(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Read projects for a given user
     * @return OK
     */
    v1ProjectsUser(userUid: string): Observable<ProjectDto[]> {
        let url_ = this.baseUrl + "/v1/projects/user/{userUid}";
        if (userUid === undefined || userUid === null)
            throw new Error("The parameter 'userUid' must be defined.");
        url_ = url_.replace("{userUid}", encodeURIComponent("" + userUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProjectsUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProjectsUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDto[]>;
        }));
    }

    protected processV1ProjectsUser(response: HttpResponseBase): Observable<ProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a project. Note this will overwrite the existing content.
    Comments and logo are optional and will be updated if provided.
     * @param body (optional) 
     * @return OK
     */
    v1ProjectsUpdate(body: ProjectUpdateRequestDto | undefined): Observable<ProjectDto> {
        let url_ = this.baseUrl + "/v1/projects/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProjectsUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProjectsUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDto>;
        }));
    }

    protected processV1ProjectsUpdate(response: HttpResponseBase): Observable<ProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1ProjectsUsersAdd(body: ProjectAddUserDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/projects/users/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProjectsUsersAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProjectsUsersAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1ProjectsUsersAdd(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1ProjectsUsersRemove(projectUid: string, userUid: string): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/projects/{projectUid}/users/remove/{userUid}";
        if (projectUid === undefined || projectUid === null)
            throw new Error("The parameter 'projectUid' must be defined.");
        url_ = url_.replace("{projectUid}", encodeURIComponent("" + projectUid));
        if (userUid === undefined || userUid === null)
            throw new Error("The parameter 'userUid' must be defined.");
        url_ = url_.replace("{userUid}", encodeURIComponent("" + userUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProjectsUsersRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProjectsUsersRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1ProjectsUsersRemove(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1ProjectsCopy(projectUid: string): Observable<ProjectDto> {
        let url_ = this.baseUrl + "/v1/projects/{projectUid}/copy";
        if (projectUid === undefined || projectUid === null)
            throw new Error("The parameter 'projectUid' must be defined.");
        url_ = url_.replace("{projectUid}", encodeURIComponent("" + projectUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProjectsCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProjectsCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDto>;
        }));
    }

    protected processV1ProjectsCopy(response: HttpResponseBase): Observable<ProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new project. Not saved to the database at this point.
     * @return OK
     */
    v1ProjectsCreateProject(): Observable<ProjectCreateDto> {
        let url_ = this.baseUrl + "/v1/projects/create/project";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProjectsCreateProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProjectsCreateProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectCreateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectCreateDto>;
        }));
    }

    protected processV1ProjectsCreateProject(response: HttpResponseBase): Observable<ProjectCreateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectCreateDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a sorted list of available protective devices, filtered by system voltage.
     * @param body (optional) 
     * @return OK
     */
    v1ProtectionListVoltage(body: SystemVoltageDto | undefined): Observable<StringSelectDto[]> {
        let url_ = this.baseUrl + "/v1/protection/list/voltage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProtectionListVoltage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProtectionListVoltage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringSelectDto[]>;
        }));
    }

    protected processV1ProtectionListVoltage(response: HttpResponseBase): Observable<StringSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringSelectDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1ProtectionFrames(deviceKind: string): Observable<StringSelectDto[]> {
        let url_ = this.baseUrl + "/v1/protection/frames/{deviceKind}";
        if (deviceKind === undefined || deviceKind === null)
            throw new Error("The parameter 'deviceKind' must be defined.");
        url_ = url_.replace("{deviceKind}", encodeURIComponent("" + deviceKind));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProtectionFrames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProtectionFrames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringSelectDto[]>;
        }));
    }

    protected processV1ProtectionFrames(response: HttpResponseBase): Observable<StringSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringSelectDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1ProtectionRatings(deviceKind: string, assemblyGuid: string): Observable<IDto[]> {
        let url_ = this.baseUrl + "/v1/protection/ratings/{deviceKind}/{assemblyGuid}";
        if (deviceKind === undefined || deviceKind === null)
            throw new Error("The parameter 'deviceKind' must be defined.");
        url_ = url_.replace("{deviceKind}", encodeURIComponent("" + deviceKind));
        if (assemblyGuid === undefined || assemblyGuid === null)
            throw new Error("The parameter 'assemblyGuid' must be defined.");
        url_ = url_.replace("{assemblyGuid}", encodeURIComponent("" + assemblyGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProtectionRatings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProtectionRatings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IDto[]>;
        }));
    }

    protected processV1ProtectionRatings(response: HttpResponseBase): Observable<IDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1ProtectionRatingsAuto(deviceKind: string, assemblyGuid: string, loadCurrent: number): Observable<InDto> {
        let url_ = this.baseUrl + "/v1/protection/ratings/{deviceKind}/{assemblyGuid}/auto/{loadCurrent}";
        if (deviceKind === undefined || deviceKind === null)
            throw new Error("The parameter 'deviceKind' must be defined.");
        url_ = url_.replace("{deviceKind}", encodeURIComponent("" + deviceKind));
        if (assemblyGuid === undefined || assemblyGuid === null)
            throw new Error("The parameter 'assemblyGuid' must be defined.");
        url_ = url_.replace("{assemblyGuid}", encodeURIComponent("" + assemblyGuid));
        if (loadCurrent === undefined || loadCurrent === null)
            throw new Error("The parameter 'loadCurrent' must be defined.");
        url_ = url_.replace("{loadCurrent}", encodeURIComponent("" + loadCurrent));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProtectionRatingsAuto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProtectionRatingsAuto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InDto>;
        }));
    }

    protected processV1ProtectionRatingsAuto(response: HttpResponseBase): Observable<InDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1ProtectionRatingsRcd(): Observable<InDto[]> {
        let url_ = this.baseUrl + "/v1/protection/ratings/rcd";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProtectionRatingsRcd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProtectionRatingsRcd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InDto[]>;
        }));
    }

    protected processV1ProtectionRatingsRcd(response: HttpResponseBase): Observable<InDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Datasheet for a PV module of a given guid.
     * @param guid The guid of the requested PV module.
     * @return OK
     */
    v1PvDatasheet(guid: string): Observable<PVDatasheetDto> {
        let url_ = this.baseUrl + "/v1/pv/{guid}/datasheet";
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PvDatasheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PvDatasheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PVDatasheetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PVDatasheetDto>;
        }));
    }

    protected processV1PvDatasheet(response: HttpResponseBase): Observable<PVDatasheetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PVDatasheetDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * List of PV module manufacturers.
     * @return OK
     */
    v1PvManufacturers(): Observable<ManufacturerDto[]> {
        let url_ = this.baseUrl + "/v1/pv/manufacturers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PvManufacturers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PvManufacturers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManufacturerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManufacturerDto[]>;
        }));
    }

    protected processV1PvManufacturers(response: HttpResponseBase): Observable<ManufacturerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ManufacturerDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1PvManufacturersRanges(guid: string): Observable<StringSelectDto[]> {
        let url_ = this.baseUrl + "/v1/pv/manufacturers/{guid}/ranges";
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PvManufacturersRanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PvManufacturersRanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringSelectDto[]>;
        }));
    }

    protected processV1PvManufacturersRanges(response: HttpResponseBase): Observable<StringSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringSelectDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1PvSeriesModules(seriesGuid: string): Observable<StringSelectDto[]> {
        let url_ = this.baseUrl + "/v1/pv/series/{seriesGuid}/modules";
        if (seriesGuid === undefined || seriesGuid === null)
            throw new Error("The parameter 'seriesGuid' must be defined.");
        url_ = url_.replace("{seriesGuid}", encodeURIComponent("" + seriesGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PvSeriesModules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PvSeriesModules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringSelectDto[]>;
        }));
    }

    protected processV1PvSeriesModules(response: HttpResponseBase): Observable<StringSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringSelectDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1PvModuleDatasheetHtml(moduleGuid: string): Observable<HTMLDto> {
        let url_ = this.baseUrl + "/v1/pv/module/{moduleGuid}/datasheet/html";
        if (moduleGuid === undefined || moduleGuid === null)
            throw new Error("The parameter 'moduleGuid' must be defined.");
        url_ = url_.replace("{moduleGuid}", encodeURIComponent("" + moduleGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PvModuleDatasheetHtml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PvModuleDatasheetHtml(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HTMLDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HTMLDto>;
        }));
    }

    protected processV1PvModuleDatasheetHtml(response: HttpResponseBase): Observable<HTMLDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HTMLDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1RedirectHttpGet(url: string): Observable<ObjectResponseDto> {
        let url_ = this.baseUrl + "/v1/redirect/http/{url}/get";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1RedirectHttpGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1RedirectHttpGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObjectResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObjectResponseDto>;
        }));
    }

    protected processV1RedirectHttpGet(response: HttpResponseBase): Observable<ObjectResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ObjectResponseDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1ReportsDo(body: ReportRequestDto | undefined): Observable<PublicUrlDto> {
        let url_ = this.baseUrl + "/v1/reports/do";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ReportsDo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ReportsDo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicUrlDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicUrlDto>;
        }));
    }

    protected processV1ReportsDo(response: HttpResponseBase): Observable<PublicUrlDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublicUrlDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1ReportsExport(body: ExportRequestDto | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v1/reports/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ReportsExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ReportsExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processV1ReportsExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1SecurityEncrypt(body: StringDto | undefined): Observable<StringDto> {
        let url_ = this.baseUrl + "/v1/security/encrypt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SecurityEncrypt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SecurityEncrypt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringDto>;
        }));
    }

    protected processV1SecurityEncrypt(response: HttpResponseBase): Observable<StringDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1SecurityDecrypt(body: StringDto | undefined): Observable<StringDto> {
        let url_ = this.baseUrl + "/v1/security/decrypt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SecurityDecrypt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SecurityDecrypt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringDto>;
        }));
    }

    protected processV1SecurityDecrypt(response: HttpResponseBase): Observable<StringDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1SharedBillingManagementOtp(): Observable<OtpTokenDto> {
        let url_ = this.baseUrl + "/v1/shared-billing/management/otp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SharedBillingManagementOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SharedBillingManagementOtp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OtpTokenDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OtpTokenDto>;
        }));
    }

    protected processV1SharedBillingManagementOtp(response: HttpResponseBase): Observable<OtpTokenDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OtpTokenDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1SharedBillingManagementVerify(body: VerifyManagementOtpDto | undefined): Observable<SharedBillingManagementSessionDto> {
        let url_ = this.baseUrl + "/v1/shared-billing/management/verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SharedBillingManagementVerify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SharedBillingManagementVerify(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedBillingManagementSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedBillingManagementSessionDto>;
        }));
    }

    protected processV1SharedBillingManagementVerify(response: HttpResponseBase): Observable<SharedBillingManagementSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedBillingManagementSessionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param x_Shared_Billing_Session (optional) 
     * @return OK
     */
    v1SharedBillingMembersGet(x_Shared_Billing_Session: string | undefined): Observable<BillingMembershipDto[]> {
        let url_ = this.baseUrl + "/v1/shared-billing/members";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "X-Shared-Billing-Session": x_Shared_Billing_Session !== undefined && x_Shared_Billing_Session !== null ? "" + x_Shared_Billing_Session : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SharedBillingMembersGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SharedBillingMembersGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingMembershipDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingMembershipDto[]>;
        }));
    }

    protected processV1SharedBillingMembersGet(response: HttpResponseBase): Observable<BillingMembershipDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BillingMembershipDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Credit usage for the authenticated billing owner, with an inclusive start and exclusive end.
     * @return OK
     */
    v1SharedBillingUsage(startTime: Date, endTime: Date): Observable<UserCreditSummaryDto[]> {
        let url_ = this.baseUrl + "/v1/shared-billing/usage?";
        if (startTime === undefined || startTime === null)
            throw new Error("The parameter 'startTime' must be defined and cannot be null.");
        else
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === undefined || endTime === null)
            throw new Error("The parameter 'endTime' must be defined and cannot be null.");
        else
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SharedBillingUsage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SharedBillingUsage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCreditSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCreditSummaryDto[]>;
        }));
    }

    protected processV1SharedBillingUsage(response: HttpResponseBase): Observable<UserCreditSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserCreditSummaryDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param x_Shared_Billing_Session (optional) 
     * @param body (optional) 
     * @return OK
     */
    v1SharedBillingInvitationsPost(x_Shared_Billing_Session: string | undefined, body: InviteRequestDto | undefined): Observable<MembershipOperationResult> {
        let url_ = this.baseUrl + "/v1/shared-billing/invitations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "X-Shared-Billing-Session": x_Shared_Billing_Session !== undefined && x_Shared_Billing_Session !== null ? "" + x_Shared_Billing_Session : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SharedBillingInvitationsPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SharedBillingInvitationsPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MembershipOperationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MembershipOperationResult>;
        }));
    }

    protected processV1SharedBillingInvitationsPost(response: HttpResponseBase): Observable<MembershipOperationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MembershipOperationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1SharedBillingInvitationsGet(): Observable<BillingMembershipDto[]> {
        let url_ = this.baseUrl + "/v1/shared-billing/invitations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SharedBillingInvitationsGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SharedBillingInvitationsGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingMembershipDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingMembershipDto[]>;
        }));
    }

    protected processV1SharedBillingInvitationsGet(response: HttpResponseBase): Observable<BillingMembershipDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BillingMembershipDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param x_Shared_Billing_Session (optional) 
     * @return OK
     */
    v1SharedBillingInvitationsResend(invitationUid: string, x_Shared_Billing_Session: string | undefined): Observable<MembershipOperationResult> {
        let url_ = this.baseUrl + "/v1/shared-billing/invitations/{invitationUid}/resend";
        if (invitationUid === undefined || invitationUid === null)
            throw new Error("The parameter 'invitationUid' must be defined.");
        url_ = url_.replace("{invitationUid}", encodeURIComponent("" + invitationUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "X-Shared-Billing-Session": x_Shared_Billing_Session !== undefined && x_Shared_Billing_Session !== null ? "" + x_Shared_Billing_Session : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SharedBillingInvitationsResend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SharedBillingInvitationsResend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MembershipOperationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MembershipOperationResult>;
        }));
    }

    protected processV1SharedBillingInvitationsResend(response: HttpResponseBase): Observable<MembershipOperationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MembershipOperationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param x_Shared_Billing_Session (optional) 
     * @return OK
     */
    v1SharedBillingMembersDelete(membershipUid: string, x_Shared_Billing_Session: string | undefined): Observable<MembershipOperationResult> {
        let url_ = this.baseUrl + "/v1/shared-billing/members/{membershipUid}";
        if (membershipUid === undefined || membershipUid === null)
            throw new Error("The parameter 'membershipUid' must be defined.");
        url_ = url_.replace("{membershipUid}", encodeURIComponent("" + membershipUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "X-Shared-Billing-Session": x_Shared_Billing_Session !== undefined && x_Shared_Billing_Session !== null ? "" + x_Shared_Billing_Session : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SharedBillingMembersDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SharedBillingMembersDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MembershipOperationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MembershipOperationResult>;
        }));
    }

    protected processV1SharedBillingMembersDelete(response: HttpResponseBase): Observable<MembershipOperationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MembershipOperationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1SharedBillingInvitationsAccept(invitationUid: string): Observable<void> {
        let url_ = this.baseUrl + "/v1/shared-billing/invitations/{invitationUid}/accept";
        if (invitationUid === undefined || invitationUid === null)
            throw new Error("The parameter 'invitationUid' must be defined.");
        url_ = url_.replace("{invitationUid}", encodeURIComponent("" + invitationUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SharedBillingInvitationsAccept(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SharedBillingInvitationsAccept(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1SharedBillingInvitationsAccept(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1SharedBillingInvitationsDecline(invitationUid: string): Observable<void> {
        let url_ = this.baseUrl + "/v1/shared-billing/invitations/{invitationUid}/decline";
        if (invitationUid === undefined || invitationUid === null)
            throw new Error("The parameter 'invitationUid' must be defined.");
        url_ = url_.replace("{invitationUid}", encodeURIComponent("" + invitationUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SharedBillingInvitationsDecline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SharedBillingInvitationsDecline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1SharedBillingInvitationsDecline(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1SharedBillingMembership(): Observable<BillingMembershipDtoOptionDto> {
        let url_ = this.baseUrl + "/v1/shared-billing/membership";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SharedBillingMembership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SharedBillingMembership(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingMembershipDtoOptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingMembershipDtoOptionDto>;
        }));
    }

    protected processV1SharedBillingMembership(response: HttpResponseBase): Observable<BillingMembershipDtoOptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BillingMembershipDtoOptionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1SharedBillingOwner(): Observable<SharedBillingOwnerDtoOptionDto> {
        let url_ = this.baseUrl + "/v1/shared-billing/owner";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SharedBillingOwner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SharedBillingOwner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedBillingOwnerDtoOptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedBillingOwnerDtoOptionDto>;
        }));
    }

    protected processV1SharedBillingOwner(response: HttpResponseBase): Observable<SharedBillingOwnerDtoOptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedBillingOwnerDtoOptionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1SharedBillingLeave(): Observable<void> {
        let url_ = this.baseUrl + "/v1/shared-billing/leave";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SharedBillingLeave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SharedBillingLeave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1SharedBillingLeave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1SiteSettingsMotd(): Observable<MOTDDto> {
        let url_ = this.baseUrl + "/v1/siteSettings/motd";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SiteSettingsMotd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SiteSettingsMotd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MOTDDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MOTDDto>;
        }));
    }

    protected processV1SiteSettingsMotd(response: HttpResponseBase): Observable<MOTDDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MOTDDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param x (optional) 
     * @return OK
     */
    v1SiteSettingsLogs(x: number | undefined): Observable<LogDto[]> {
        let url_ = this.baseUrl + "/v1/siteSettings/logs?";
        if (x === null)
            throw new Error("The parameter 'x' cannot be null.");
        else if (x !== undefined)
            url_ += "x=" + encodeURIComponent("" + x) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SiteSettingsLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SiteSettingsLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LogDto[]>;
        }));
    }

    protected processV1SiteSettingsLogs(response: HttpResponseBase): Observable<LogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LogDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param x (optional) 
     * @param logType (optional) 
     * @return OK
     */
    v1SiteSettingsLogsType(x: number | undefined, logType: string | undefined): Observable<LogDto[]> {
        let url_ = this.baseUrl + "/v1/siteSettings/logs/type?";
        if (x === null)
            throw new Error("The parameter 'x' cannot be null.");
        else if (x !== undefined)
            url_ += "x=" + encodeURIComponent("" + x) + "&";
        if (logType === null)
            throw new Error("The parameter 'logType' cannot be null.");
        else if (logType !== undefined)
            url_ += "logType=" + encodeURIComponent("" + logType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SiteSettingsLogsType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SiteSettingsLogsType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LogDto[]>;
        }));
    }

    protected processV1SiteSettingsLogsType(response: HttpResponseBase): Observable<LogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LogDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1SiteSettingsMotdUpdate(body: MOTDDto | undefined): Observable<MOTDDto> {
        let url_ = this.baseUrl + "/v1/siteSettings/motd/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SiteSettingsMotdUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SiteSettingsMotdUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MOTDDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MOTDDto>;
        }));
    }

    protected processV1SiteSettingsMotdUpdate(response: HttpResponseBase): Observable<MOTDDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MOTDDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * List of standards for which reference information is available.
     * @return OK
     */
    v1StandardsReference(): Observable<StringSelectDto[]> {
        let url_ = this.baseUrl + "/v1/standards/reference";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1StandardsReference(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1StandardsReference(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringSelectDto[]>;
        }));
    }

    protected processV1StandardsReference(response: HttpResponseBase): Observable<StringSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringSelectDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1StandardsReferenceTables(standardGuid: string): Observable<StringSelectDto[]> {
        let url_ = this.baseUrl + "/v1/standards/reference/{standardGuid}/tables";
        if (standardGuid === undefined || standardGuid === null)
            throw new Error("The parameter 'standardGuid' must be defined.");
        url_ = url_.replace("{standardGuid}", encodeURIComponent("" + standardGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1StandardsReferenceTables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1StandardsReferenceTables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringSelectDto[]>;
        }));
    }

    protected processV1StandardsReferenceTables(response: HttpResponseBase): Observable<StringSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringSelectDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1StandardsReferenceHTML(tableGuid: string): Observable<HTMLDto> {
        let url_ = this.baseUrl + "/v1/standards/reference/{tableGuid}/HTML";
        if (tableGuid === undefined || tableGuid === null)
            throw new Error("The parameter 'tableGuid' must be defined.");
        url_ = url_.replace("{tableGuid}", encodeURIComponent("" + tableGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1StandardsReferenceHTML(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1StandardsReferenceHTML(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HTMLDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HTMLDto>;
        }));
    }

    protected processV1StandardsReferenceHTML(response: HttpResponseBase): Observable<HTMLDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HTMLDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the standard for a given secondary method GUID.
     * @return OK
     */
    v1StandardsInstallationSecondary(secondaryMethodGuid: string): Observable<StandardDto> {
        let url_ = this.baseUrl + "/v1/standards/installation/secondary/{secondaryMethodGuid}";
        if (secondaryMethodGuid === undefined || secondaryMethodGuid === null)
            throw new Error("The parameter 'secondaryMethodGuid' must be defined.");
        url_ = url_.replace("{secondaryMethodGuid}", encodeURIComponent("" + secondaryMethodGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1StandardsInstallationSecondary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1StandardsInstallationSecondary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StandardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StandardDto>;
        }));
    }

    protected processV1StandardsInstallationSecondary(response: HttpResponseBase): Observable<StandardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StandardDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1SubscriptionsSessionCheckout(body: CreateCheckoutSessionRequestDto | undefined): Observable<CheckOutSessionDto> {
        let url_ = this.baseUrl + "/v1/subscriptions/session/checkout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SubscriptionsSessionCheckout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SubscriptionsSessionCheckout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckOutSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckOutSessionDto>;
        }));
    }

    protected processV1SubscriptionsSessionCheckout(response: HttpResponseBase): Observable<CheckOutSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CheckOutSessionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1SubscriptionsSessionPortal(body: CreatePortalSessionRequestDto | undefined): Observable<PortalSessionDto> {
        let url_ = this.baseUrl + "/v1/subscriptions/session/portal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SubscriptionsSessionPortal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SubscriptionsSessionPortal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortalSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortalSessionDto>;
        }));
    }

    protected processV1SubscriptionsSessionPortal(response: HttpResponseBase): Observable<PortalSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortalSessionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1SubscriptionsBalance(): Observable<CustomerBalanceDto> {
        let url_ = this.baseUrl + "/v1/subscriptions/balance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SubscriptionsBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SubscriptionsBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerBalanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerBalanceDto>;
        }));
    }

    protected processV1SubscriptionsBalance(response: HttpResponseBase): Observable<CustomerBalanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerBalanceDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1SubscriptionsBalanceUser(body: GetCustomerBalanceRequestDto | undefined): Observable<CustomerBalanceDto> {
        let url_ = this.baseUrl + "/v1/subscriptions/balance/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SubscriptionsBalanceUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SubscriptionsBalanceUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerBalanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerBalanceDto>;
        }));
    }

    protected processV1SubscriptionsBalanceUser(response: HttpResponseBase): Observable<CustomerBalanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerBalanceDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1SubscriptionsBalanceAdjust(body: AdjustCustomerBalanceRequestDto | undefined): Observable<CustomerBalanceDto> {
        let url_ = this.baseUrl + "/v1/subscriptions/balance/adjust";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SubscriptionsBalanceAdjust(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SubscriptionsBalanceAdjust(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerBalanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerBalanceDto>;
        }));
    }

    protected processV1SubscriptionsBalanceAdjust(response: HttpResponseBase): Observable<CustomerBalanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerBalanceDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1Support(reference: string): Observable<SupportDataDto> {
        let url_ = this.baseUrl + "/v1/support/{reference}";
        if (reference === undefined || reference === null)
            throw new Error("The parameter 'reference' must be defined.");
        url_ = url_.replace("{reference}", encodeURIComponent("" + reference));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1Support(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1Support(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportDataDto>;
        }));
    }

    protected processV1Support(response: HttpResponseBase): Observable<SupportDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SupportDataDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1Users(userUid: string): Observable<UserDto> {
        let url_ = this.baseUrl + "/v1/users/{userUid}";
        if (userUid === undefined || userUid === null)
            throw new Error("The parameter 'userUid' must be defined.");
        url_ = url_.replace("{userUid}", encodeURIComponent("" + userUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1Users(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1Users(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processV1Users(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1UsersUpdate(body: UserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/v1/users/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UsersUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UsersUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processV1UsersUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1UsersRoles(userUid: string): Observable<RoleDto[]> {
        let url_ = this.baseUrl + "/v1/users/{userUid}/roles";
        if (userUid === undefined || userUid === null)
            throw new Error("The parameter 'userUid' must be defined.");
        url_ = url_.replace("{userUid}", encodeURIComponent("" + userUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UsersRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UsersRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto[]>;
        }));
    }

    protected processV1UsersRoles(response: HttpResponseBase): Observable<RoleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1UsersRolesVerify(userUid: string): Observable<BooleanDto> {
        let url_ = this.baseUrl + "/v1/users/{userUid}/roles/verify";
        if (userUid === undefined || userUid === null)
            throw new Error("The parameter 'userUid' must be defined.");
        url_ = url_.replace("{userUid}", encodeURIComponent("" + userUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UsersRolesVerify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UsersRolesVerify(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanDto>;
        }));
    }

    protected processV1UsersRolesVerify(response: HttpResponseBase): Observable<BooleanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BooleanDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1UsersProfileIsComplete(userUid: string): Observable<BooleanDto> {
        let url_ = this.baseUrl + "/v1/users/{userUid}/profile/isComplete";
        if (userUid === undefined || userUid === null)
            throw new Error("The parameter 'userUid' must be defined.");
        url_ = url_.replace("{userUid}", encodeURIComponent("" + userUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UsersProfileIsComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UsersProfileIsComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanDto>;
        }));
    }

    protected processV1UsersProfileIsComplete(response: HttpResponseBase): Observable<BooleanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BooleanDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    profileUpdate(body: UserDto | undefined): Observable<BooleanDto> {
        let url_ = this.baseUrl + "/profile/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfileUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfileUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanDto>;
        }));
    }

    protected processProfileUpdate(response: HttpResponseBase): Observable<BooleanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BooleanDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1UsersProfilePhotoUpdate(body: UserUpdatePhotoDto | undefined): Observable<PublicUrlDto> {
        let url_ = this.baseUrl + "/v1/users/profile/photo/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UsersProfilePhotoUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UsersProfilePhotoUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicUrlDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicUrlDto>;
        }));
    }

    protected processV1UsersProfilePhotoUpdate(response: HttpResponseBase): Observable<PublicUrlDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublicUrlDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1UsersSearchEmail(email: string): Observable<UserDtoOptionDto> {
        let url_ = this.baseUrl + "/v1/users/search/email/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UsersSearchEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UsersSearchEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoOptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoOptionDto>;
        }));
    }

    protected processV1UsersSearchEmail(response: HttpResponseBase): Observable<UserDtoOptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDtoOptionDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1UsersCurrentuser(): Observable<CurrentUserDto> {
        let url_ = this.baseUrl + "/v1/users/currentuser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UsersCurrentuser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UsersCurrentuser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentUserDto>;
        }));
    }

    protected processV1UsersCurrentuser(response: HttpResponseBase): Observable<CurrentUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CurrentUserDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    v1UsersSearchSearchString(searchString: string): Observable<UserSelectDto[]> {
        let url_ = this.baseUrl + "/v1/users/search/searchString/{searchString}";
        if (searchString === undefined || searchString === null)
            throw new Error("The parameter 'searchString' must be defined.");
        url_ = url_.replace("{searchString}", encodeURIComponent("" + searchString));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UsersSearchSearchString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UsersSearchSearchString(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSelectDto[]>;
        }));
    }

    protected processV1UsersSearchSearchString(response: HttpResponseBase): Observable<UserSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserSelectDto[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * --------------------------------------------
    Update Email
    --------------------------------------------
     * @param body (optional) 
     * @return OK
     */
    v1UsersEmailUpdate(body: UserUpdateEmailDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/v1/users/email/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UsersEmailUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UsersEmailUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processV1UsersEmailUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1UsersEmailUpdateAdmin(body: AdminUserUpdateEmailDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/v1/users/email/update/admin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UsersEmailUpdateAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UsersEmailUpdateAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processV1UsersEmailUpdateAdmin(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * --------------------------------------------
    Unregister / delete account
    --------------------------------------------
     * @param body (optional) 
     * @return OK
     */
    v1UsersUnregister(body: UserOTPDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/v1/users/unregister";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UsersUnregister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UsersUnregister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1UsersUnregister(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * --------------------------------------------
    OTP (One Time Password)
    --------------------------------------------
     * @return OK
     */
    v1UsersOtpEmail(): Observable<TokenDto> {
        let url_ = this.baseUrl + "/v1/users/otp/email";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UsersOtpEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UsersOtpEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenDto>;
        }));
    }

    protected processV1UsersOtpEmail(response: HttpResponseBase): Observable<TokenDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TokenDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    v1UsersOtpEmailProvided(body: EmailDto | undefined): Observable<TokenDto> {
        let url_ = this.baseUrl + "/v1/users/otp/email/provided";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UsersOtpEmailProvided(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UsersOtpEmailProvided(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenDto>;
        }));
    }

    protected processV1UsersOtpEmailProvided(response: HttpResponseBase): Observable<TokenDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TokenDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a voltage model for a given dc voltage.
     * @param voltage The value of the dc voltage in volts.
     * @return OK
     */
    v1VoltageDc(voltage: number): Observable<SystemVoltageDto> {
        let url_ = this.baseUrl + "/v1/voltage/dc/{voltage}";
        if (voltage === undefined || voltage === null)
            throw new Error("The parameter 'voltage' must be defined.");
        url_ = url_.replace("{voltage}", encodeURIComponent("" + voltage));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1VoltageDc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1VoltageDc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemVoltageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemVoltageDto>;
        }));
    }

    protected processV1VoltageDc(response: HttpResponseBase): Observable<SystemVoltageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SystemVoltageDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a voltage model for a given single-phase ac voltage.
     * @param voltage The line to earth value of the ac voltage in volts.
     * @param phaseAngle The phase angle in degrees of the ac voltage.
     * @param frequency The frequency in hertz of the ac voltage.
     * @return OK
     */
    v1VoltageAc1ph(voltage: number, phaseAngle: number, frequency: number): Observable<SystemVoltageDto> {
        let url_ = this.baseUrl + "/v1/voltage/ac1ph/{voltage}/{phaseAngle}/{frequency}";
        if (voltage === undefined || voltage === null)
            throw new Error("The parameter 'voltage' must be defined.");
        url_ = url_.replace("{voltage}", encodeURIComponent("" + voltage));
        if (phaseAngle === undefined || phaseAngle === null)
            throw new Error("The parameter 'phaseAngle' must be defined.");
        url_ = url_.replace("{phaseAngle}", encodeURIComponent("" + phaseAngle));
        if (frequency === undefined || frequency === null)
            throw new Error("The parameter 'frequency' must be defined.");
        url_ = url_.replace("{frequency}", encodeURIComponent("" + frequency));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1VoltageAc1ph(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1VoltageAc1ph(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemVoltageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemVoltageDto>;
        }));
    }

    protected processV1VoltageAc1ph(response: HttpResponseBase): Observable<SystemVoltageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SystemVoltageDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a voltage model for a given three-phase ac voltage.
     * @param voltage The line to line value of the ac voltage in volts.
     * @param phaseAngle The phase angle in degrees of the ac voltage.
     * @param frequency The frequency in hertz of the ac voltage.
     * @return OK
     */
    v1VoltageAc3ph(voltage: number, phaseAngle: number, frequency: number): Observable<SystemVoltageDto> {
        let url_ = this.baseUrl + "/v1/voltage/ac3ph/{voltage}/{phaseAngle}/{frequency}";
        if (voltage === undefined || voltage === null)
            throw new Error("The parameter 'voltage' must be defined.");
        url_ = url_.replace("{voltage}", encodeURIComponent("" + voltage));
        if (phaseAngle === undefined || phaseAngle === null)
            throw new Error("The parameter 'phaseAngle' must be defined.");
        url_ = url_.replace("{phaseAngle}", encodeURIComponent("" + phaseAngle));
        if (frequency === undefined || frequency === null)
            throw new Error("The parameter 'frequency' must be defined.");
        url_ = url_.replace("{frequency}", encodeURIComponent("" + frequency));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1VoltageAc3ph(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1VoltageAc3ph(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemVoltageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemVoltageDto>;
        }));
    }

    protected processV1VoltageAc3ph(response: HttpResponseBase): Observable<SystemVoltageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SystemVoltageDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a voltage model for a given three-phase and neutral (TPN) ac voltage.
     * @param voltage The line to line value of the ac voltage in volts.
     * @param phaseAngle The phase angle in degrees of the ac voltage.
     * @param frequency The frequency in hertz of the ac voltage.
     * @return OK
     */
    v1VoltageTpn(voltage: number, phaseAngle: number, frequency: number): Observable<SystemVoltageDto> {
        let url_ = this.baseUrl + "/v1/voltage/tpn/{voltage}/{phaseAngle}/{frequency}";
        if (voltage === undefined || voltage === null)
            throw new Error("The parameter 'voltage' must be defined.");
        url_ = url_.replace("{voltage}", encodeURIComponent("" + voltage));
        if (phaseAngle === undefined || phaseAngle === null)
            throw new Error("The parameter 'phaseAngle' must be defined.");
        url_ = url_.replace("{phaseAngle}", encodeURIComponent("" + phaseAngle));
        if (frequency === undefined || frequency === null)
            throw new Error("The parameter 'frequency' must be defined.");
        url_ = url_.replace("{frequency}", encodeURIComponent("" + frequency));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1VoltageTpn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1VoltageTpn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemVoltageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemVoltageDto>;
        }));
    }

    protected processV1VoltageTpn(response: HttpResponseBase): Observable<SystemVoltageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SystemVoltageDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Determine the states (low voltage, dc or ac, etc. for a given voltage).
     * @param body (optional) 
     * @return OK
     */
    v1VoltageState(body: SystemVoltageDto | undefined): Observable<VoltageStateDto> {
        let url_ = this.baseUrl + "/v1/voltage/state";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1VoltageState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1VoltageState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoltageStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoltageStateDto>;
        }));
    }

    protected processV1VoltageState(response: HttpResponseBase): Observable<VoltageStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoltageStateDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ACB_IEC60947Dto {
    assemblyGuid?: string | undefined;
    rating?: number;
    autoRating?: boolean;
    ir?: number;
}

export interface ACB_IEC60947DtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: ACB_IEC60947Dto[] | undefined;
}

export interface ACHVEarthingDto {
    case?: string | undefined;
    soilResistivity?: number;
}

export interface ACHVEarthingDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: ACHVEarthingDto[] | undefined;
}

export interface ACLVEarthingDto {
    case?: string | undefined;
    soilResistivity?: number;
}

export interface ACLVEarthingDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: ACLVEarthingDto[] | undefined;
}

export interface ActionQuoteDto {
    action?: string | undefined;
    cost?: number;
    key?: string | undefined;
    displayName?: string | undefined;
    hasSufficientCredits?: boolean;
}

export interface AdjustCustomerBalanceRequestDto {
    userUid?: string | undefined;
    amount?: number;
    description?: string | undefined;
}

export interface AdminBudgetUpdateRequestDto {
    userUid?: string | undefined;
    paygBudget?: number;
}

export interface AdminFreeTierResetRequestDto {
    userUid?: string | undefined;
}

export interface AdminUserUpdateEmailDto {
    userUid?: string | undefined;
    newEmail?: string | undefined;
}

export interface AmbientTemperatureDto {
    airTemperature?: TemperatureDto;
    groundTemperature?: TemperatureDto;
}

export interface ArmourDUDto {
    value?: string | undefined;
}

export interface ArmourDto {
    material?: ArmourDUDto;
    materialCode?: string | undefined;
    materialName?: string | undefined;
    csa?: CSADto;
}

export interface ArmourDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: ArmourDto[] | undefined;
}

export interface BS7671DeratingRequestDto {
    selectedCable?: SelectedCableDtoOptionDto;
    singleCoreArrangement?: SingleCoreArrangementDtoOptionDto;
    systemVoltage?: SystemVoltageDto;
    load?: LoadDto;
    protectiveDevice?: DeviceDtoOptionDto;
    secondaryMethod?: string | undefined;
    ambientTemperature?: AmbientTemperatureDto;
    buried?: BuriedDto;
    grouping?: GroupingDto;
    thermalInsulation?: DoubleOptionDto;
    userDefinedFactor?: UserDefinedFactorDtoOptionDto;
    simpleDesignCurrent?: boolean;
}

export interface BillingMembershipDto {
    uid?: string | undefined;
    billingOwnerUid?: string | undefined;
    email?: string | undefined;
    memberUid?: string | undefined;
    status?: string | undefined;
    createdTime?: DateTimeDto;
    expiresTime?: DateTimeDto;
    joinedTime?: DateTimeDtoOptionDto;
}

export interface BillingMembershipDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: BillingMembershipDto[] | undefined;
}

export interface BooleanDto {
    value?: boolean;
}

export interface BudgetUpdateRequestDto {
    paygBudget?: number;
}

export interface BudgetUpdateResultDto {
    paygBudget?: number;
    paygBudgetConsumed?: number;
}

export interface BuriedDto {
    depth?: LengthDto;
    soilThermalResistivity?: ThermalResistivityDto;
}

export interface BuriedDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: BuriedDto[] | undefined;
}

export interface CSADto {
    csa?: number;
}

export interface CableCommentsDto {
    cableUid?: string | undefined;
    dataHTML?: string | undefined;
}

export interface CableCommentsDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: CableCommentsDto[] | undefined;
}

export interface CableConstructionDto {
    layer?: string | undefined;
    description?: string | undefined;
    material?: CableLayerMaterialDtoOptionDto;
    thickness?: LengthMMDto;
    outsideDiameter?: LengthMMDto;
    csa?: CSADto;
    weight?: WeightPMDto;
}

export interface CableCreateDto {
    cable?: CableDto;
    comments?: CableCommentsDto;
}

export interface CableCreateRequestDto {
    projectUid?: string | undefined;
}

export interface CableDatasheetDto {
    guid?: string | undefined;
    manufacturer?: ManufacturerDto;
    summary?: CableLibrarySummaryDto;
    construction?: CableConstructionDto[] | undefined;
    electrical?: CableElectricalDto;
}

export interface CableDatasheetDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: CableDatasheetDto[] | undefined;
}

export interface CableDto {
    uid?: string | undefined;
    createdTime?: DateTimeDto;
    createdByUser?: string | undefined;
    lastUpdatedTime?: DateTimeDto;
    projectUid?: string | undefined;
    identification?: IdentificationDto;
    recordStatus?: string | undefined;
    supply?: SupplyDto;
    load?: LoadDto;
    protection?: ProtectionDto;
    faultSource?: ModelFaultSourceDto;
    earthFaultLoop?: EFLDtoOptionDto;
    selectedCable?: SelectedCableDtoOptionDto;
    installation?: InstallationDto;
    voltageDrop?: VoltageDropPointDto;
    commentsUrl?: StringOptionDto;
    settings?: SettingsDto;
}

export interface CableDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: CableDto[] | undefined;
}

export interface CableEarthingDto {
    earthing?: EarthingDto;
    settings?: EarthingSettingsDto;
}

export interface CableElectricalDto {
    resistances?: CableResistancesDto;
    temperatures?: CableTemperaturesDto;
}

export interface CableEndFaultDto {
    shortCircuitMax?: FaultLevelDto;
    shortCircuitMin?: FaultLevelDto;
    earthFaultMax?: FaultLevelDto;
    earthFaultMin?: FaultLevelDto;
}

export interface CableFaultDto {
    case?: string | undefined;
    cableEndFault?: CableEndFaultDto;
    cableWithstand?: CableFaultWithstandDto;
}

export interface CableFaultRequestDto {
    systemVoltage?: SystemVoltageDto;
    selectedCable?: SelectedCableDto;
    modelFaultSource?: ModelFaultSourceDto;
    cableImpedance?: ImpedanceDto;
}

export interface CableFaultWithstandDto {
    shortCircuitI2t?: number;
    earthFaultI2t?: number;
    cableWithstandI2t?: number;
    cableRating1s?: number;
    cableRating3s?: number;
    status?: CalculationStatusDto;
}

export interface CableLayerMaterialDto {
    guid?: string | undefined;
    code?: string | undefined;
}

export interface CableLayerMaterialDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: CableLayerMaterialDto[] | undefined;
}

export interface CableLibraryDto {
    guid?: string | undefined;
    description?: string | undefined;
    csa?: number[] | undefined;
}

export interface CableLibrarySummaryDto {
    descriptionSource?: string | undefined;
    descriptionLibrary?: string | undefined;
    csa?: CSADto;
    cores?: number;
    conductor?: ConductorDto;
    insulation?: InsulationDto;
    armour?: ArmourDtoOptionDto;
    overallDiameter?: LengthMMDto;
    weight?: WeightPMDto;
}

export interface CableRangeDto {
    source?: CableSourceDto;
    library?: CableLibraryDto[] | undefined;
}

export interface CableResistancesDto {
    rdc20pm?: RpmDto;
    rdcTpm?: RpmDto;
}

export interface CableSourceDto {
    guid?: string | undefined;
    description?: string | undefined;
    manufacturer?: ManufacturerDto;
}

export interface CableSummaryDto {
    uid?: string | undefined;
    projectUid?: string | undefined;
    designation?: string | undefined;
    description?: string | undefined;
    supply?: string | undefined;
    load?: string | undefined;
}

export interface CableTemperaturesDto {
    maxOperating?: TemperatureDto;
    maxFinal?: TemperatureDto;
}

export interface CableUpdateRequestDto {
    cable?: CableDto;
    comments?: CableCommentsDtoOptionDto;
}

export interface CalculationSettingsDto {
    disableVoltageFilter?: boolean;
    simpleDesignCurrent?: boolean;
}

export interface CalculationStatusDto {
    case?: string | undefined;
    message?: string | undefined;
}

export interface ChargeQuoteResultDto {
    token?: string | undefined;
    quote?: ActionQuoteDto;
}

export interface ChargeRequestDto {
    token?: string | undefined;
}

export interface ChargeResultDto {
    freeChargeApplied?: BooleanDto;
}

export interface CheckOutSessionDto {
    url?: string | undefined;
}

export interface Classification {
    readonly tag?: number;
    readonly isClass1SolidConductor?: boolean;
    readonly isClass2StrandedConductor?: boolean;
    readonly isClass5FlexibleConductor?: boolean;
    readonly isClass6FlexibleConductor?: boolean;
}

export interface ComplexDto {
    real?: number;
    imaginary?: number;
    magnitude?: number;
    phaseRadians?: number;
    phaseDegrees?: number;
}

export interface ComplexPowerDto {
    s?: ComplexDto;
}

export interface ComplexPowerDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: ComplexPowerDto[] | undefined;
}

export interface ConductorDUDto {
    value?: string | undefined;
}

export interface ConductorDto {
    material?: ConductorDUDto;
    materialCode?: string | undefined;
    materialName?: string | undefined;
    diameter?: LengthMMDto;
    classification?: Classification;
}

export interface ConductorTemperatureRequestDto {
    cableCurrent?: number;
    conductorRating?: number;
    ambientTemp?: number;
    cableLibraryGuid?: string | undefined;
}

export interface ConductorTemperatureResultDto {
    conductorTemperature?: number;
    status?: CalculationStatusDto;
}

export interface CountryReferenceValuesDto {
    groundAmbientTemperature?: number;
    airAmbientTemperature?: number;
    soilThermalResistivity?: number;
}

export interface CreateCheckoutSessionRequestDto {
    tier?: SubscriptionTierDto;
    successUrl?: string | undefined;
    cancelUrl?: string | undefined;
}

export interface CreatePortalSessionRequestDto {
    returnUrl?: string | undefined;
}

export interface CreditActionCostDto {
    key?: string | undefined;
    displayName?: string | undefined;
    cost?: CreditPricingDto;
}

export interface CreditPricingDto {
    pricingType?: string | undefined;
    credits?: Int32OptionDto;
    calculated?: CreditQuoteContextInt32FSharpFuncOptionDto;
}

export interface CreditQuoteContextDto {
    key?: string | undefined;
    cableCount?: number;
}

export interface CreditQuoteContextInt32FSharpFunc {
}

export interface CreditQuoteContextInt32FSharpFuncOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: CreditQuoteContextInt32FSharpFunc[] | undefined;
}

export interface CurrentUserDto {
    user?: UserDto;
    roles?: RoleDto[] | undefined;
    subscription?: SubscriptionDto;
    profileComplete?: BooleanDto;
}

export interface CustomerBalanceDto {
    balance?: number;
}

export interface DCEarthingDto {
    case?: string | undefined;
    soilResistivity?: number;
}

export interface DCEarthingDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: DCEarthingDto[] | undefined;
}

export interface DateTimeDto {
    value?: string | undefined;
}

export interface DateTimeDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: DateTimeDto[] | undefined;
}

export interface DeratedCurrentCalculationDto {
    standard?: StandardDto;
    table?: StandardTableDto;
    deratingFactors?: DeratingDto[] | undefined;
    base?: IDto;
    actual?: SustainedCurrentDto;
    suggested?: SustainedCurrentDtoOptionDto;
    conductorTemperature?: ConductorTemperatureResultDto;
    status?: CalculationStatusDto;
}

export interface DeratingDto {
    reference?: string | undefined;
    value?: number;
}

export interface DesignCurrentDto {
    loadCurrent?: number;
    protectiveDeviceCurrent?: number;
    protectiveDeviceMargin?: number;
    designCurrent?: number;
    status?: CalculationStatusDto;
}

export interface DesignCurrentRequestDto {
    load?: LoadDto;
    device?: DeviceDtoOptionDto;
    simpleDesignCurrent?: boolean;
}

export interface DeviceDto {
    deviceKind?: string | undefined;
    generalDevice?: GeneralDeviceDtoOptionDto;
    acB_IEC60947?: ACB_IEC60947DtoOptionDto;
    mccB_IEC60947?: MCCB_IEC60947DtoOptionDto;
    mcB_IEC60898?: MCB_IEC60898DtoOptionDto;
    fuse_IEC60269?: Fuse_IEC60269DtoOptionDto;
    fuse_BS3036?: Fuse_BS3036DtoOptionDto;
    fuse_BS88?: Fuse_BS88DtoOptionDto;
    rcbO_IEC61009?: RCBO_IEC61009DtoOptionDto;
}

export interface DeviceDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: DeviceDto[] | undefined;
}

export interface DoubleOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: number[] | undefined;
}

export interface DoubleSelectDto {
    label?: string | undefined;
    value?: number;
}

export interface EFLCalculationRequestDto {
    userValues?: EFLDto;
    systemVoltage?: SystemVoltageDto;
    load?: LoadDto;
    device?: DeviceDtoOptionDto;
    rcd?: RCDDtoOptionDto;
    earthing?: EarthingDto;
    cableImpedance?: ImpedanceDto;
    modelFaultSource?: ModelFaultSourceDto;
}

export interface EFLCalculationResultDto {
    required?: boolean;
    z1?: number;
    z2?: number;
    ze?: number;
    zs?: number;
    maxZs?: EFLMaximumZsDtoOptionDto;
    maxDisconnectionTime?: EFLMaxDisconnectionTimeDtoOptionDto;
    status?: CalculationStatusDto;
}

export interface EFLDto {
    userMaxDisconnectionTime?: boolean;
    userMaxDisconnectionTimeValue?: number;
    userIa?: boolean;
    userIaValue?: number;
    userZs?: boolean;
    userZsValue?: number;
}

export interface EFLDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: EFLDto[] | undefined;
}

export interface EFLMaxDisconnectionTimeDto {
    case?: string | undefined;
    value?: number;
}

export interface EFLMaxDisconnectionTimeDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: EFLMaxDisconnectionTimeDto[] | undefined;
}

/** ---- Result DTOs ---- */
export interface EFLMaximumZsDto {
    case?: string | undefined;
    value?: number;
}

export interface EFLMaximumZsDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: EFLMaximumZsDto[] | undefined;
}

export interface EFLRequiredRequestDto {
    systemVoltage?: SystemVoltageDto;
    load?: LoadDto;
    device?: DeviceDtoOptionDto;
    earthing?: EarthingDto;
}

export interface ERA6930P3DeratingRequestDto {
    selectedCable?: SelectedCableDtoOptionDto;
    singleCoreArrangement?: SingleCoreArrangementDtoOptionDto;
    systemVoltage?: SystemVoltageDto;
    load?: LoadDto;
    protectiveDevice?: DeviceDtoOptionDto;
    secondaryMethod?: string | undefined;
    ambientTemperature?: AmbientTemperatureDto;
    buried?: BuriedDto;
    grouping?: GroupingDto;
    userDefinedFactor?: UserDefinedFactorDtoOptionDto;
    simpleDesignCurrent?: boolean;
}

export interface ERA6930P5DeratingRequestDto {
    selectedCable?: SelectedCableDtoOptionDto;
    singleCoreArrangement?: SingleCoreArrangementDtoOptionDto;
    systemVoltage?: SystemVoltageDto;
    load?: LoadDto;
    protectiveDevice?: DeviceDtoOptionDto;
    secondaryMethod?: string | undefined;
    ambientTemperature?: AmbientTemperatureDto;
    buried?: BuriedDto;
    grouping?: GroupingDto;
    userDefinedFactor?: UserDefinedFactorDtoOptionDto;
    simpleDesignCurrent?: boolean;
}

export interface EarthingDto {
    case?: string | undefined;
    dc?: DCEarthingDtoOptionDto;
    aclv?: ACLVEarthingDtoOptionDto;
    achv?: ACHVEarthingDtoOptionDto;
}

export interface EarthingSettingsDto {
    screenBonded?: boolean;
    armourBonded?: boolean;
    useSpareCoreForEF?: boolean;
    externalCPC?: ExternalCPCDtoOptionDto;
}

export interface EfficiencyDto {
    point?: number;
}

export interface EmailDto {
    email?: string | undefined;
}

export interface EmailDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: EmailDto[] | undefined;
}

export interface EmailSignInDto {
    emailToken?: string | undefined;
    isLoginEnabled?: boolean;
    isEmailPasswordLoginEnabled?: boolean;
}

export interface EmailSignInRequestDto {
    email?: string | undefined;
}

export interface EquipmentTypeDUDto {
    value?: string | undefined;
}

export interface ExchangeRateDto {
    base?: string | undefined;
    target?: string | undefined;
    rate?: number;
}

export interface ExportRequestDto {
    projectUid?: string | undefined;
    cableUids?: string[] | undefined;
}

export interface ExternalCPCDto {
    conductor?: string | undefined;
    csa?: number;
}

export interface ExternalCPCDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: ExternalCPCDto[] | undefined;
}

export interface FactorsBS7671Dto {
    primaryMethodGuid?: string | undefined;
    secondaryMethodGuid?: string | undefined;
    grouping?: GroupingDto;
    ambientTemperature?: AmbientTemperatureDto;
    buried?: BuriedDtoOptionDto;
    simultaneousOverload?: boolean;
    thermalInsulationThickness?: DoubleOptionDto;
    userDefinedFactor?: UserDefinedFactorDtoOptionDto;
}

export interface FactorsBS7671DtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: FactorsBS7671Dto[] | undefined;
}

export interface FactorsERA6930P3Dto {
    primaryMethodGuid?: string | undefined;
    secondaryMethodGuid?: string | undefined;
    grouping?: GroupingDto;
    ambientTemperature?: AmbientTemperatureDto;
    buried?: BuriedDtoOptionDto;
    userDefinedFactor?: UserDefinedFactorDtoOptionDto;
}

export interface FactorsERA6930P3DtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: FactorsERA6930P3Dto[] | undefined;
}

export interface FactorsERA6930P5Dto {
    primaryMethodGuid?: string | undefined;
    secondaryMethodGuid?: string | undefined;
    grouping?: GroupingDto;
    ambientTemperature?: AmbientTemperatureDto;
    buried?: BuriedDtoOptionDto;
    userDefinedFactor?: UserDefinedFactorDtoOptionDto;
}

export interface FactorsERA6930P5DtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: FactorsERA6930P5Dto[] | undefined;
}

export interface FactorsIEC60502P2Dto {
    primaryMethodGuid?: string | undefined;
    secondaryMethodGuid?: string | undefined;
    grouping?: GroupingDto;
    ambientTemperature?: AmbientTemperatureDto;
    buried?: BuriedDtoOptionDto;
    numberOfTrays?: Int32OptionDto;
    userDefinedFactor?: UserDefinedFactorDtoOptionDto;
}

export interface FactorsIEC60502P2DtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: FactorsIEC60502P2Dto[] | undefined;
}

export interface FactorsUDRDto {
    sustainedRating?: number;
    referenceTemperature?: number;
    parallelCables?: number;
}

export interface FactorsUDRDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: FactorsUDRDto[] | undefined;
}

export interface FaultImpedanceFromLevelRequestDto {
    i?: number;
    pf?: PFDto;
    ie?: number;
    pFe?: PFDto;
    systemVoltage?: SystemVoltageDto;
    earthing?: EarthingDto;
}

export interface FaultImpedanceFromLevelResponseDto {
    r?: number;
    x?: number;
    re?: number;
    xe?: number;
}

export interface FaultLevelDto {
    i?: number;
    pf?: PFDto;
}

export interface FaultLevelFromImpedanceRequestDto {
    r?: number;
    re?: number;
    x?: number;
    xe?: number;
    systemVoltage?: SystemVoltageDto;
}

export interface FaultLevelFromImpedanceResponseDto {
    i?: number;
    pf?: PFDto;
    ie?: number;
    pFe?: PFDto;
}

export interface Flag64Dto {
    flag64?: string | undefined;
}

export interface Flag64DtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: Flag64Dto[] | undefined;
}

export interface Fuse_BS3036Dto {
    assemblyGuid?: string | undefined;
    rating?: number;
    autoRating?: boolean;
}

export interface Fuse_BS3036DtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: Fuse_BS3036Dto[] | undefined;
}

export interface Fuse_BS88Dto {
    assemblyGuid?: string | undefined;
    rating?: number;
    autoRating?: boolean;
}

export interface Fuse_BS88DtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: Fuse_BS88Dto[] | undefined;
}

export interface Fuse_IEC60269Dto {
    assemblyGuid?: string | undefined;
    rating?: number;
    autoRating?: boolean;
}

export interface Fuse_IEC60269DtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: Fuse_IEC60269Dto[] | undefined;
}

export interface GeneralACLoadDTO {
    ib?: number;
    pf?: number;
    lagging?: boolean;
}

export interface GeneralACLoadDTOOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: GeneralACLoadDTO[] | undefined;
}

export interface GeneralDCLoadDTO {
    ib?: number;
}

export interface GeneralDCLoadDTOOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: GeneralDCLoadDTO[] | undefined;
}

export interface GeneralDeviceDto {
    ioc?: number;
    ief?: number;
}

export interface GeneralDeviceDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: GeneralDeviceDto[] | undefined;
}

export interface GetCustomerBalanceRequestDto {
    userUid?: string | undefined;
}

export interface GroupingDto {
    parallelCables?: number;
    numberOfCircuits?: number;
    circuitSpacing?: SpacingDto;
}

export interface GuidSelectDto {
    label?: string | undefined;
    value?: string;
}

export interface HTMLDto {
    html?: string | undefined;
}

export interface HTMLDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: HTMLDto[] | undefined;
}

export interface IDto {
    i?: number;
}

export interface IDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: IDto[] | undefined;
}

export interface IEC60502P2DeratingRequestDto {
    selectedCable?: SelectedCableDtoOptionDto;
    singleCoreArrangement?: SingleCoreArrangementDtoOptionDto;
    systemVoltage?: SystemVoltageDto;
    load?: LoadDto;
    protectiveDevice?: DeviceDtoOptionDto;
    secondaryMethod?: string | undefined;
    ambientTemperature?: AmbientTemperatureDto;
    buried?: BuriedDto;
    grouping?: GroupingDto;
    numberOfTrays?: Int32OptionDto;
    userDefinedFactor?: UserDefinedFactorDtoOptionDto;
    simpleDesignCurrent?: boolean;
}

export interface IdentificationDto {
    designation?: string | undefined;
    description?: string | undefined;
    source?: string | undefined;
    destination?: string | undefined;
}

export interface ImpdeanceDCDto {
    r1?: RDto;
    r2?: RDto;
}

export interface ImpdeanceDCDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: ImpdeanceDCDto[] | undefined;
}

export interface ImpedanceAC1PhDto {
    z1?: ComplexDto;
    z2?: ComplexDto;
}

export interface ImpedanceAC1PhDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: ImpedanceAC1PhDto[] | undefined;
}

export interface ImpedanceAC3PhDto {
    z1?: ComplexDto;
    z2?: ComplexDto;
    z0?: ComplexDto;
}

export interface ImpedanceAC3PhDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: ImpedanceAC3PhDto[] | undefined;
}

export interface ImpedanceDto {
    case?: string | undefined;
    dc?: ImpdeanceDCDtoOptionDto;
    aC1Ph?: ImpedanceAC1PhDtoOptionDto;
    aC3Ph?: ImpedanceAC3PhDtoOptionDto;
}

export interface ImpedanceRequestDto {
    systemVoltage?: SystemVoltageDto;
    cableEarthing?: CableEarthingDto;
    selectedCable?: SelectedCableDto;
    installation?: InstallationDto;
    earthing?: CableEarthingDto;
    operatingTemperature?: number;
}

export interface ImpedanceResultDto {
    r?: number;
    x?: number;
    z?: number;
    xrRatio?: DoubleOptionDto;
}

export interface InDto {
    i?: number;
}

/** ----------------------------------------------------------------------------------------------- Installation ----------------------------------------------------------------------------------------------- */
export interface InstallationDto {
    circuitLength?: number;
    singleCoreArrangement?: SingleCoreArrangementDtoOptionDto;
    standardGuid?: string | undefined;
    udrFactors?: FactorsUDRDtoOptionDto;
    bS7671Factors?: FactorsBS7671DtoOptionDto;
    erA6930P3Factors?: FactorsERA6930P3DtoOptionDto;
    erA6930P5Factors?: FactorsERA6930P5DtoOptionDto;
    ieC60502Factors?: FactorsIEC60502P2DtoOptionDto;
    projectAirTemperature?: number;
    projectGroundTemperature?: number;
    projectSoilThermalResistivity?: number;
}

export interface InsulationDUDto {
    value?: string | undefined;
}

export interface InsulationDto {
    material?: InsulationDUDto;
    materialCode?: string | undefined;
    materialName?: string | undefined;
    thickness?: LengthMMDto;
}

export interface Int32OptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: number[] | undefined;
}

export interface Int64Dto {
    value?: number;
}

export interface InviteRequestDto {
    email?: string | undefined;
}

export interface IpDto {
    i?: number;
    pf?: PFDto;
}

export interface IpDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: IpDto[] | undefined;
}

export interface KFactorDto {
    kFactor?: number;
}

export interface LengthDto {
    length?: number;
}

export interface LengthMMDto {
    length?: number;
}

export interface LoadDto {
    key?: string | undefined;
    case?: string | undefined;
    generalDCLoad?: GeneralDCLoadDTOOptionDto;
    generalACLoad?: GeneralACLoadDTOOptionDto;
    efficiency?: EfficiencyDto;
}

export interface LoadTypeDto {
    key?: string | undefined;
    description?: string | undefined;
    requireEfficiency?: boolean;
}

export interface LogDto {
    name?: string | undefined;
    type?: LogTypeDto;
    createdAt?: DateTimeDto;
    status?: LogStatusDto;
    details?: string | undefined;
}

export interface LogStatusDto {
    case?: string | undefined;
}

export interface LogTypeDto {
    value?: string | undefined;
}

export interface MCB_IEC60898Dto {
    assemblyGuid?: string | undefined;
    rating?: number;
    autoRating?: boolean;
}

export interface MCB_IEC60898DtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: MCB_IEC60898Dto[] | undefined;
}

export interface MCCB_IEC60947Dto {
    assemblyGuid?: string | undefined;
    rating?: number;
    autoRating?: boolean;
    ir?: number;
}

export interface MCCB_IEC60947DtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: MCCB_IEC60947Dto[] | undefined;
}

export interface MOTDDto {
    html?: string | undefined;
    endDate?: DateTimeDto;
    uid?: string | undefined;
}

export interface ManufacturerDto {
    guid?: string | undefined;
    name?: string | undefined;
    logoUrl?: string | undefined;
}

export interface MaterialConductorDto {
    guid?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    density?: number;
    specificHeatCapacity?: number;
    volumetricHeatCapacity?: number;
    resistivity?: DoubleOptionDto;
    temperatureCoefficient?: number;
}

export interface MaterialInsulationDto {
    guid?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    density?: number;
    specificHeatCapacity?: number;
    volumetricHeatCapacity?: number;
    maxOperatingTemperature?: DoubleOptionDto;
    maxFinalTemperature?: DoubleOptionDto;
}

export interface MaterialInsulationDtoFSharpOption {
    value?: MaterialInsulationDto;
}

export interface MembershipOperationResult {
    uid?: string | undefined;
    emailSent?: boolean;
}

export interface MetalRateDto {
    code?: string | undefined;
    base?: string | undefined;
    rateKg?: number;
    rateTroyOunce?: number;
    rateTonne?: number;
}

/** Model DTOs */
export interface ModelFaultSourceDto {
    case?: string | undefined;
    r?: number;
    x?: number;
    re?: number;
    xe?: number;
    shortCircuitT?: number;
    earthFaultT?: number;
}

export interface ModuleTypeDUDto {
    value?: string | undefined;
}

export interface ObjectResponseDto {
    response?: any;
}

export interface OtpTokenDto {
    token?: string | undefined;
}

export interface PDto {
    p?: number;
}

export interface PDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: PDto[] | undefined;
}

export interface PFDto {
    pf?: number;
    lagging?: boolean;
}

export interface PVDatasheetDto {
    series?: PVModuleSeriesDto;
    module?: PVModuleDto;
}

export interface PVModuleDto {
    guid?: string | undefined;
    description?: string | undefined;
    type?: ModuleTypeDUDto[] | undefined;
    properties?: PVPropertiesDto[] | undefined;
}

export interface PVModuleSeriesDto {
    guid?: string | undefined;
    manufacturer?: ManufacturerDto;
    description?: string | undefined;
}

export interface PVPropertiesDto {
    p?: number;
    v?: number;
    i?: number;
    voc?: number;
    isc?: number;
    eff?: number;
}

export interface PortalSessionDto {
    url?: string | undefined;
}

export interface PowerLossDto {
    case?: string | undefined;
    dc?: PDtoOptionDto;
    aC1Ph?: ComplexPowerDtoOptionDto;
    aC3Ph?: ComplexPowerDtoOptionDto;
}

export interface PowerLossRequestDto {
    systemVoltage?: SystemVoltageDto;
    load?: LoadDto;
    cableImpedance?: ImpedanceDto;
}

export interface PowerRequestDto {
    voltage?: SystemVoltageDto;
    current?: SystemCurrentDto;
}

/** ----------------------------------------------------------------------------------------------- Primary and Secondary Methods ----------------------------------------------------------------------------------------------- */
export interface PrimaryMethodSelectDto {
    value?: string;
    label?: string | undefined;
}

export interface PrimaryMethodsDtoRequest {
    libraryGuid?: string | undefined;
    systemVoltage?: SystemVoltageDto;
    standardGuid?: string | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface ProjectAddUserDto {
    projectUid?: string | undefined;
    userEmail?: string | undefined;
}

export interface ProjectCommentsDto {
    projectUid?: string | undefined;
    dataHTML?: string | undefined;
}

export interface ProjectCommentsDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: ProjectCommentsDto[] | undefined;
}

export interface ProjectCreateDto {
    project?: ProjectDto;
    comments?: ProjectCommentsDto;
}

export interface ProjectDto {
    uid?: string | undefined;
    createdTime?: DateTimeDto;
    createdByUser?: string | undefined;
    lastUpdatedTime?: DateTimeDto;
    projectNumber?: string | undefined;
    projectName?: string | undefined;
    country?: string | undefined;
    recordStatus?: string | undefined;
    logoUrl?: PublicUrlDto;
    referenceValues?: ProjectReferenceValuesDto;
    users?: string[] | undefined;
    commentsUrl?: StringOptionDto;
}

export interface ProjectDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: ProjectDto[] | undefined;
}

export interface ProjectReferenceValuesDto {
    groundAmbientTemperature?: number;
    airAmbientTemperature?: number;
    soilThermalResistivity?: number;
}

export interface ProjectUpdateRequestDto {
    project?: ProjectDto;
    comments?: ProjectCommentsDtoOptionDto;
    logo64Data?: StringOptionDto;
}

export interface ProtectionDto {
    device?: DeviceDtoOptionDto;
    rcd?: RCDDtoOptionDto;
}

export interface PublicUrlDto {
    value?: string | undefined;
}

export interface QDto {
    q?: number;
}

export interface RCBO_IEC61009Dto {
    assemblyGuid?: string | undefined;
    rating?: number;
    autoRating?: boolean;
}

export interface RCBO_IEC61009DtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: RCBO_IEC61009Dto[] | undefined;
}

export interface RCDDto {
    rating?: number;
}

export interface RCDDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: RCDDto[] | undefined;
}

export interface RDto {
    value?: number;
}

export interface ReportDUDto {
    value?: string | undefined;
}

export interface ReportRequestDto {
    report?: ReportDUDto;
    uids?: string[] | undefined;
}

export interface RequestCalculateI {
    systemVoltage?: SystemVoltageDto;
    power?: PDto;
    efficiency?: EfficiencyDto;
}

export interface RequestCalculateIpFromP {
    systemVoltage?: SystemVoltageDto;
    power?: PDto;
    efficiency?: EfficiencyDto;
    pf?: PFDto;
}

export interface RequestCalculateIpFromS {
    systemVoltage?: SystemVoltageDto;
    apparentPower?: SDto;
    efficiency?: EfficiencyDto;
    pf?: PFDto;
}

export interface RequestCalculatePower {
    systemVoltage?: SystemVoltageDto;
    load?: LoadDto;
}

export interface RoleDto {
    role?: string | undefined;
}

export interface RpmDto {
    value?: number;
}

export interface SDto {
    s?: number;
}

export interface SecondaryMethodSelectDto {
    value?: string;
    label?: string | undefined;
    imageUrl?: StringOptionDto;
}

export interface SecondaryMethodsDtoRequest {
    libraryGuid?: string | undefined;
    systemVoltage?: SystemVoltageDto;
    standardGuid?: string | undefined;
    primaryGuid?: string | undefined;
}

export interface SelectedCableDto {
    manufacturerGuid?: string | undefined;
    sourceGuid?: string | undefined;
    libraryGuid?: string | undefined;
    csa?: number;
}

export interface SelectedCableDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: SelectedCableDto[] | undefined;
}

export interface SettingsDto {
    values?: CalculationSettingsDto;
}

export interface SharedBillingManagementSessionDto {
    sessionToken?: string | undefined;
    expiresTimeUTC?: DateTimeDto;
}

/** Public owner profile only; personal access must not return the user's own profile as an owner. */
export interface SharedBillingOwnerDto {
    displayName?: string | undefined;
    photoUrl?: PublicUrlDto;
}

export interface SharedBillingOwnerDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: SharedBillingOwnerDto[] | undefined;
}

export interface SingleCoreArrangementDto {
    case?: string | undefined;
    description?: string | undefined;
    spacing?: SpacingDtoOptionDto;
}

export interface SingleCoreArrangementDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: SingleCoreArrangementDto[] | undefined;
}

export interface SpacingDto {
    case?: string | undefined;
    edgeToEdge?: number;
}

export interface SpacingDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: SpacingDto[] | undefined;
}

export interface StandardDto {
    guid?: string | undefined;
    reference?: string | undefined;
    title?: string | undefined;
    year?: number;
}

export interface StandardTableDto {
    guid?: string | undefined;
    reference?: string | undefined;
    title?: string | undefined;
}

export interface StandardsDtoRequest {
    libraryGuid?: string | undefined;
    systemVoltage?: SystemVoltageDto;
}

export interface StandardsRequest {
    libraryGuid?: string | undefined;
    systemVoltage?: SystemVoltageDto;
}

export interface StringDto {
    value?: string | undefined;
}

export interface StringOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: string[] | undefined;
}

export interface StringSelectDto {
    label?: string | undefined;
    value?: string | undefined;
}

export interface StripeMeterEventAuditDto {
    identifier?: string | undefined;
    stripeCustomerId?: string | undefined;
    userUid?: string | undefined;
    billingUserUid?: string | undefined;
    eventName?: string | undefined;
    actionKey?: string | undefined;
    credits?: number;
    eventTimestamp?: DateTimeDto;
    recordedAt?: DateTimeDto;
    livemode?: boolean;
}

export interface SubscriptionDto {
    tier?: SubscriptionTierDto;
    lastInvoiceId?: string | undefined;
    creditAllowance?: number;
    creditConsumed?: number;
    paygBudget?: number;
    paygBudgetConsumed?: number;
    currentPeriodEndUTC?: DateTimeDto;
    cancelAtPeriodEnd?: BooleanDto;
    status?: string | undefined;
}

export interface SubscriptionTierDto {
    tier?: string | undefined;
}

export interface SupplyDto {
    systemVoltage?: SystemVoltageDto;
    earthing?: CableEarthingDto;
}

export interface SupportDataDto {
    case?: string | undefined;
    project?: ProjectDtoOptionDto;
    cable?: CableDtoOptionDto;
}

export interface SustainedCurrentDto {
    i?: IDto;
    csa?: CSADto;
}

export interface SustainedCurrentDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: SustainedCurrentDto[] | undefined;
}

export interface SymbolDto {
    code?: string | undefined;
    name?: string | undefined;
}

export interface SystemCurrentDto {
    case?: string | undefined;
    dc?: IDtoOptionDto;
    ac?: IpDtoOptionDto;
}

export interface SystemVoltageDto {
    case?: string | undefined;
    dc?: VDtoOptionDto;
    aC1ph?: VoltageAC1phDtoOptionDto;
    aC3ph?: VoltageAC3phDtoOptionDto;
    tpn?: VoltageAC3phDtoOptionDto;
}

export interface TemperatureDto {
    temperature?: number;
}

export interface ThermalResistivityDto {
    thermalResistivity?: number;
}

export interface TokenDto {
    token?: string | undefined;
}

export interface UDRDeratingRequestDto {
    selectedCable?: SelectedCableDtoOptionDto;
    csa?: number;
    load?: LoadDto;
    protectiveDevice?: DeviceDtoOptionDto;
    sustainedRating?: number;
    referenceTemperature?: number;
    simpleDesignCurrent?: boolean;
}

export interface UDto {
    u?: ComplexDto;
}

export interface UoDto {
    uo?: ComplexDto;
}

export interface UserCreditSummaryDto {
    userUid?: string | undefined;
    totalCredits?: number;
    email?: StringOptionDto;
}

export interface UserDefinedFactorDto {
    description?: string | undefined;
    value?: number;
}

export interface UserDefinedFactorDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: UserDefinedFactorDto[] | undefined;
}

export interface UserDto {
    uid?: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    photoUrl?: PublicUrlDto;
    subscription?: SubscriptionDto;
}

export interface UserDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: UserDto[] | undefined;
}

export interface UserOTPDto {
    userUid?: string | undefined;
    otpToken?: string | undefined;
    otp?: string | undefined;
}

export interface UserSelectDto {
    key?: string | undefined;
    user?: UserDto;
}

export interface UserUpdateEmailDto {
    userUid?: string | undefined;
    newEmail?: string | undefined;
    otpToken?: string | undefined;
    otp?: string | undefined;
}

export interface UserUpdatePhotoDto {
    userUid?: string | undefined;
    photo64Data?: string | undefined;
}

export interface VDto {
    v?: number;
}

export interface VDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: VDto[] | undefined;
}

export interface VerifyManagementOtpDto {
    otpToken?: string | undefined;
    otp?: string | undefined;
}

export interface VoltageAC1phDto {
    uo?: number;
    frequency?: number;
}

export interface VoltageAC1phDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: VoltageAC1phDto[] | undefined;
}

export interface VoltageAC3phDto {
    u?: number;
    frequency?: number;
}

export interface VoltageAC3phDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: VoltageAC3phDto[] | undefined;
}

export interface VoltageDropAC1PhDto {
    uo?: UoDto;
    percent?: number;
    point?: number;
}

export interface VoltageDropAC1PhDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: VoltageDropAC1PhDto[] | undefined;
}

export interface VoltageDropAC3PhDto {
    u?: UDto;
    percent?: number;
    point?: number;
}

export interface VoltageDropAC3PhDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: VoltageDropAC3PhDto[] | undefined;
}

export interface VoltageDropDCDto {
    v?: VDto;
    percent?: number;
    point?: number;
}

export interface VoltageDropDCDtoOptionDto {
    isSome?: boolean;
    isNone?: boolean;
    value?: VoltageDropDCDto[] | undefined;
}

export interface VoltageDropDto {
    case?: string | undefined;
    dc?: VoltageDropDCDtoOptionDto;
    aC1Ph?: VoltageDropAC1PhDtoOptionDto;
    aC3Ph?: VoltageDropAC3PhDtoOptionDto;
    status?: CalculationStatusDto;
}

export interface VoltageDropPointDto {
    maximum?: number;
}

export interface VoltageDropRequestDto {
    systemVoltage?: SystemVoltageDto;
    load?: LoadDto;
    cableImpedance?: ImpedanceDto;
    maxVoltageDropPoint?: number;
}

export interface VoltageStateDto {
    isLowVoltage?: boolean;
    isHighVoltage?: boolean;
    isDC?: boolean;
    isAC?: boolean;
}

export interface WeightPMDto {
    weightPM?: number;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    return _observableThrow(new ApiException(message, status, response, headers, result));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}